/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as VendorRouteRouteImport } from './routes/vendor/route'
import { Route as VendorLoginRouteImport } from './routes/vendor-login'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAssetsRouteImport } from './routes/_authenticated/assets'
import { Route as AuthenticatedAuditLogsRouteImport } from './routes/_authenticated/audit-logs'
import { Route as AuthenticatedAuditsRouteImport } from './routes/_authenticated/audits'
import { Route as AuthenticatedCalibrationRouteImport } from './routes/_authenticated/calibration'
import { Route as AuthenticatedComplianceRouteImport } from './routes/_authenticated/compliance'
import { Route as AuthenticatedCondemnationRouteImport } from './routes/_authenticated/condemnation'
import { Route as AuthenticatedConfigurationRouteImport } from './routes/_authenticated/configuration'
import { Route as AuthenticatedContractsRouteImport } from './routes/_authenticated/contracts'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedDisposalsRouteImport } from './routes/_authenticated/disposals'
import { Route as AuthenticatedFinanceRouteImport } from './routes/_authenticated/finance'
import { Route as AuthenticatedGrnsRouteImport } from './routes/_authenticated/grns'
import { Route as AuthenticatedIndentsRouteImport } from './routes/_authenticated/indents'
import { Route as AuthenticatedInsuranceRouteImport } from './routes/_authenticated/insurance'
import { Route as AuthenticatedIntegratedAssetsRouteImport } from './routes/_authenticated/integrated-assets'
import { Route as AuthenticatedInventoryRouteImport } from './routes/_authenticated/inventory'
import { Route as AuthenticatedMyAllocationsRouteImport } from './routes/_authenticated/my-allocations'
import { Route as AuthenticatedPreventiveMaintenanceRouteImport } from './routes/_authenticated/preventive-maintenance'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPurchaseOrdersRouteImport } from './routes/_authenticated/purchase-orders'
import { Route as AuthenticatedPurchaseRequestsRouteImport } from './routes/_authenticated/purchase-requests'
import { Route as AuthenticatedQuotationComparisonTemplatesRouteImport } from './routes/_authenticated/quotation-comparison-templates'
import { Route as AuthenticatedQuotationTemplatesRouteImport } from './routes/_authenticated/quotation-templates'
import { Route as AuthenticatedReportBreakdownRouteImport } from './routes/_authenticated/report-breakdown'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedRfqsRouteImport } from './routes/_authenticated/rfqs'
import { Route as AuthenticatedSparesRouteImport } from './routes/_authenticated/spares'
import { Route as AuthenticatedStoreIndentsRouteImport } from './routes/_authenticated/store-indents'
import { Route as AuthenticatedTicketsRouteImport } from './routes/_authenticated/tickets'
import { Route as AuthenticatedTransfersRouteImport } from './routes/_authenticated/transfers'
import { Route as AuthenticatedWorkOrdersRouteImport } from './routes/_authenticated/work-orders'
import { Route as AssetSplatRouteImport } from './routes/asset.$'
import { Route as VendorIndexRouteImport } from './routes/vendor/index'
import { Route as VendorProfileRouteImport } from './routes/vendor/profile'
import { Route as AuthenticatedAssetsIndexRouteImport } from './routes/_authenticated/assets.index'
import { Route as AuthenticatedAssetsImportRouteImport } from './routes/_authenticated/assets.import'
import { Route as AuthenticatedAssetsNewRouteImport } from './routes/_authenticated/assets.new'
import { Route as AuthenticatedAssetsQrLabelsRouteImport } from './routes/_authenticated/assets.qr-labels'
import { Route as AuthenticatedAuditsIndexRouteImport } from './routes/_authenticated/audits.index'
import { Route as AuthenticatedAuditsAuditIdRouteImport } from './routes/_authenticated/audits.$auditId'
import { Route as AuthenticatedAuditsNewRouteImport } from './routes/_authenticated/audits.new'
import { Route as AuthenticatedCondemnationIndexRouteImport } from './routes/_authenticated/condemnation.index'
import { Route as AuthenticatedCondemnationIdRouteImport } from './routes/_authenticated/condemnation.$id'
import { Route as AuthenticatedCondemnationNewRouteImport } from './routes/_authenticated/condemnation.new'
import { Route as AuthenticatedContractsIndexRouteImport } from './routes/_authenticated/contracts.index'
import { Route as AuthenticatedContractsContractIdRouteImport } from './routes/_authenticated/contracts.$contractId'
import { Route as AuthenticatedContractsNewRouteImport } from './routes/_authenticated/contracts.new'
import { Route as AuthenticatedDisposalsIndexRouteImport } from './routes/_authenticated/disposals.index'
import { Route as AuthenticatedDisposalsNewRouteImport } from './routes/_authenticated/disposals.new'
import { Route as AuthenticatedFinanceCapitalisationRouteImport } from './routes/_authenticated/finance.capitalisation'
import { Route as AuthenticatedFinanceDashboardRouteImport } from './routes/_authenticated/finance.dashboard'
import { Route as AuthenticatedFinanceDepreciationRouteImport } from './routes/_authenticated/finance.depreciation'
import { Route as AuthenticatedFinanceDepreciationLedgerRouteImport } from './routes/_authenticated/finance.depreciation-ledger'
import { Route as AuthenticatedFinanceDepreciationRulesRouteImport } from './routes/_authenticated/finance.depreciation-rules'
import { Route as AuthenticatedFinanceDepreciationScheduleRouteImport } from './routes/_authenticated/finance.depreciation-schedule'
import { Route as AuthenticatedFinanceDisposalsRouteImport } from './routes/_authenticated/finance.disposals'
import { Route as AuthenticatedFinanceFixedAssetRegisterRouteImport } from './routes/_authenticated/finance.fixed-asset-register'
import { Route as AuthenticatedGrnsIndexRouteImport } from './routes/_authenticated/grns.index'
import { Route as AuthenticatedGrnsGrnIdRouteImport } from './routes/_authenticated/grns.$grnId'
import { Route as AuthenticatedGrnsNewRouteImport } from './routes/_authenticated/grns.new'
import { Route as AuthenticatedGrnsNewFromPoRouteImport } from './routes/_authenticated/grns.new-from-po'
import { Route as AuthenticatedIndentsIndexRouteImport } from './routes/_authenticated/indents.index'
import { Route as AuthenticatedIndentsIndentIdRouteImport } from './routes/_authenticated/indents.$indentId'
import { Route as AuthenticatedIndentsEditRouteImport } from './routes/_authenticated/indents..edit'
import { Route as AuthenticatedIndentsNewRouteImport } from './routes/_authenticated/indents.new'
import { Route as AuthenticatedInsuranceIndexRouteImport } from './routes/_authenticated/insurance.index'
import { Route as AuthenticatedInsurancePolicyIdRouteImport } from './routes/_authenticated/insurance.$policyId'
import { Route as AuthenticatedInsuranceNewRouteImport } from './routes/_authenticated/insurance.new'
import { Route as AuthenticatedPurchaseOrdersIndexRouteImport } from './routes/_authenticated/purchase-orders.index'
import { Route as AuthenticatedPurchaseOrdersPoIdRouteImport } from './routes/_authenticated/purchase-orders.$poId'
import { Route as AuthenticatedPurchaseOrdersNewRouteImport } from './routes/_authenticated/purchase-orders.new'
import { Route as AuthenticatedQuotationComparisonTemplatesIndexRouteImport } from './routes/_authenticated/quotation-comparison-templates.index'
import { Route as AuthenticatedQuotationComparisonTemplatesTemplateIdRouteImport } from './routes/_authenticated/quotation-comparison-templates.$templateId'
import { Route as AuthenticatedQuotationComparisonTemplatesNewRouteImport } from './routes/_authenticated/quotation-comparison-templates.new'
import { Route as AuthenticatedQuotationTemplatesIndexRouteImport } from './routes/_authenticated/quotation-templates.index'
import { Route as AuthenticatedQuotationTemplatesTemplateIdRouteImport } from './routes/_authenticated/quotation-templates.$templateId'
import { Route as AuthenticatedQuotationTemplatesNewRouteImport } from './routes/_authenticated/quotation-templates.new'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports.index'
import { Route as AuthenticatedReportsReportIdRouteImport } from './routes/_authenticated/reports.$reportId'
import { Route as AuthenticatedReportsAmcRegisterRouteImport } from './routes/_authenticated/reports.amc-register'
import { Route as AuthenticatedReportsAssetHistoryRouteImport } from './routes/_authenticated/reports.asset-history'
import { Route as AuthenticatedReportsAssetRegisterRouteImport } from './routes/_authenticated/reports.asset-register'
import { Route as AuthenticatedReportsAssetReliabilityRouteImport } from './routes/_authenticated/reports.asset-reliability'
import { Route as AuthenticatedReportsAssetTicketHistoryRouteImport } from './routes/_authenticated/reports.asset-ticket-history'
import { Route as AuthenticatedReportsAssetTransferRegisterRouteImport } from './routes/_authenticated/reports.asset-transfer-register'
import { Route as AuthenticatedReportsAuditDiscrepanciesRouteImport } from './routes/_authenticated/reports.audit-discrepancies'
import { Route as AuthenticatedReportsBreakdownAnalysisRouteImport } from './routes/_authenticated/reports.breakdown-analysis'
import { Route as AuthenticatedReportsCalibrationDueRouteImport } from './routes/_authenticated/reports.calibration-due'
import { Route as AuthenticatedReportsCalibrationStatusRouteImport } from './routes/_authenticated/reports.calibration-status'
import { Route as AuthenticatedReportsCondemnationRegisterRouteImport } from './routes/_authenticated/reports.condemnation-register'
import { Route as AuthenticatedReportsCrossDepartmentTicketsRouteImport } from './routes/_authenticated/reports.cross-department-tickets'
import { Route as AuthenticatedReportsDepartmentSpareUsageRouteImport } from './routes/_authenticated/reports.department-spare-usage'
import { Route as AuthenticatedReportsDisposalRegisterRouteImport } from './routes/_authenticated/reports.disposal-register'
import { Route as AuthenticatedReportsDowntimeRouteImport } from './routes/_authenticated/reports.downtime'
import { Route as AuthenticatedReportsEngineerPerformanceRouteImport } from './routes/_authenticated/reports.engineer-performance'
import { Route as AuthenticatedReportsFixedAssetRegisterRouteImport } from './routes/_authenticated/reports.fixed-asset-register'
import { Route as AuthenticatedReportsGrnRegisterRouteImport } from './routes/_authenticated/reports.grn-register'
import { Route as AuthenticatedReportsInsuranceClaimsRouteImport } from './routes/_authenticated/reports.insurance-claims'
import { Route as AuthenticatedReportsInsuranceRegisterRouteImport } from './routes/_authenticated/reports.insurance-register'
import { Route as AuthenticatedReportsLicenceComplianceRouteImport } from './routes/_authenticated/reports.licence-compliance'
import { Route as AuthenticatedReportsLowStockSparesRouteImport } from './routes/_authenticated/reports.low-stock-spares'
import { Route as AuthenticatedReportsNabhEvidenceRouteImport } from './routes/_authenticated/reports.nabh-evidence'
import { Route as AuthenticatedReportsOpenTicketsRouteImport } from './routes/_authenticated/reports.open-tickets'
import { Route as AuthenticatedReportsPmComplianceRouteImport } from './routes/_authenticated/reports.pm-compliance'
import { Route as AuthenticatedReportsPoRegisterRouteImport } from './routes/_authenticated/reports.po-register'
import { Route as AuthenticatedReportsProcurementCycleRouteImport } from './routes/_authenticated/reports.procurement-cycle'
import { Route as AuthenticatedReportsRepeatedBreakdownAssetsRouteImport } from './routes/_authenticated/reports.repeated-breakdown-assets'
import { Route as AuthenticatedReportsSpareConsumptionRouteImport } from './routes/_authenticated/reports.spare-consumption'
import { Route as AuthenticatedReportsSpareCostRouteImport } from './routes/_authenticated/reports.spare-cost'
import { Route as AuthenticatedReportsSpareMovementRegisterRouteImport } from './routes/_authenticated/reports.spare-movement-register'
import { Route as AuthenticatedReportsSpareStockRegisterRouteImport } from './routes/_authenticated/reports.spare-stock-register'
import { Route as AuthenticatedReportsSpareStockReorderRouteImport } from './routes/_authenticated/reports.spare-stock-reorder'
import { Route as AuthenticatedReportsSpareTransferRegisterRouteImport } from './routes/_authenticated/reports.spare-transfer-register'
import { Route as AuthenticatedReportsTicketDepartmentBreakdownRouteImport } from './routes/_authenticated/reports.ticket-department-breakdown'
import { Route as AuthenticatedReportsTicketRegisterRouteImport } from './routes/_authenticated/reports.ticket-register'
import { Route as AuthenticatedReportsTicketSlaBreachRouteImport } from './routes/_authenticated/reports.ticket-sla-breach'
import { Route as AuthenticatedReportsTicketSpareUsageRouteImport } from './routes/_authenticated/reports.ticket-spare-usage'
import { Route as AuthenticatedReportsUserAuditLogRouteImport } from './routes/_authenticated/reports.user-audit-log'
import { Route as AuthenticatedReportsVendorTicketsRouteImport } from './routes/_authenticated/reports.vendor-tickets'
import { Route as AuthenticatedReportsWarrantyExpiryRouteImport } from './routes/_authenticated/reports.warranty-expiry'
import { Route as AuthenticatedRfqsIndexRouteImport } from './routes/_authenticated/rfqs.index'
import { Route as AuthenticatedRfqsRfqIdRouteImport } from './routes/_authenticated/rfqs.$rfqId'
import { Route as AuthenticatedRfqsNewRouteImport } from './routes/_authenticated/rfqs.new'
import { Route as AuthenticatedSparesIndexRouteImport } from './routes/_authenticated/spares.index'
import { Route as AuthenticatedSparesSpareIdRouteImport } from './routes/_authenticated/spares.$spareId'
import { Route as AuthenticatedSparesNewRouteImport } from './routes/_authenticated/spares.new'
import { Route as AuthenticatedSparesTransfersRouteImport } from './routes/_authenticated/spares.transfers'
import { Route as AuthenticatedStoreIndentsIndexRouteImport } from './routes/_authenticated/store-indents.index'
import { Route as AuthenticatedStoreIndentsIdRouteImport } from './routes/_authenticated/store-indents.$id'
import { Route as AuthenticatedStoreIndentsNewRouteImport } from './routes/_authenticated/store-indents.new'
import { Route as AuthenticatedTicketsIndexRouteImport } from './routes/_authenticated/tickets.index'
import { Route as AuthenticatedTicketsTicketIdRouteImport } from './routes/_authenticated/tickets.$ticketId'
import { Route as AuthenticatedTicketsNewRouteImport } from './routes/_authenticated/tickets.new'
import { Route as AuthenticatedTransfersIndexRouteImport } from './routes/_authenticated/transfers.index'
import { Route as AuthenticatedTransfersTransferIdRouteImport } from './routes/_authenticated/transfers.$transferId'
import { Route as AuthenticatedTransfersNewRouteImport } from './routes/_authenticated/transfers.new'
import { Route as AuthenticatedWorkOrdersIndexRouteImport } from './routes/_authenticated/work-orders.index'
import { Route as AuthenticatedWorkOrdersWoIdRouteImport } from './routes/_authenticated/work-orders.$woId'
import { Route as AuthenticatedWorkOrdersNewRouteImport } from './routes/_authenticated/work-orders.new'
import { Route as VendorGrnsIndexRouteImport } from './routes/vendor/grns.index'
import { Route as VendorPurchaseOrdersIndexRouteImport } from './routes/vendor/purchase-orders.index'
import { Route as VendorPurchaseOrdersPoIdRouteImport } from './routes/vendor/purchase-orders.$poId'
import { Route as VendorRfqsIndexRouteImport } from './routes/vendor/rfqs.index'
import { Route as VendorRfqsRfqIdRouteImport } from './routes/vendor/rfqs.$rfqId'
import { Route as AuthenticatedAssetsAssetIdIndexRouteImport } from './routes/_authenticated/assets.$assetId.index'
import { Route as AuthenticatedAssetsAssetIdEditRouteImport } from './routes/_authenticated/assets.$assetId.edit'
import { Route as AuthenticatedAssetsAssetIdReportIssueRouteImport } from './routes/_authenticated/assets.$assetId.report-issue'
import { Route as AuthenticatedAuditsAuditIdIndexRouteImport } from './routes/_authenticated/audits.$auditId.index'
import { Route as AuthenticatedAuditsAuditIdDiscrepanciesRouteImport } from './routes/_authenticated/audits.$auditId.discrepancies'
import { Route as AuthenticatedAuditsAuditIdExecuteRouteImport } from './routes/_authenticated/audits.$auditId.execute'
import { Route as AuthenticatedAuditsAuditIdSignoffRouteImport } from './routes/_authenticated/audits.$auditId.signoff'
import { Route as AuthenticatedComplianceLicencesIndexRouteImport } from './routes/_authenticated/compliance.licences.index'
import { Route as AuthenticatedComplianceLicencesNewRouteImport } from './routes/_authenticated/compliance.licences.new'
import { Route as AuthenticatedContractsContractIdIndexRouteImport } from './routes/_authenticated/contracts.$contractId.index'
import { Route as AuthenticatedContractsContractIdEditRouteImport } from './routes/_authenticated/contracts.$contractId.edit'
import { Route as AuthenticatedFinanceDepreciationRunIdRouteImport } from './routes/_authenticated/finance.depreciation.$runId'
import { Route as AuthenticatedFinanceDepreciationNewRouteImport } from './routes/_authenticated/finance.depreciation.new'
import { Route as AuthenticatedGrnsGrnIdIndexRouteImport } from './routes/_authenticated/grns.$grnId.index'
import { Route as AuthenticatedGrnsGrnIdGenerateAssetsRouteImport } from './routes/_authenticated/grns.$grnId.generate-assets'
import { Route as AuthenticatedIndentsIndentIdIndexRouteImport } from './routes/_authenticated/indents.$indentId.index'
import { Route as AuthenticatedIndentsIndentIdEditRouteImport } from './routes/_authenticated/indents.$indentId.edit'
import { Route as AuthenticatedPurchaseOrdersPoIdIndexRouteImport } from './routes/_authenticated/purchase-orders.$poId.index'
import { Route as AuthenticatedPurchaseOrdersPoIdEditRouteImport } from './routes/_authenticated/purchase-orders.$poId.edit'
import { Route as AuthenticatedPurchaseOrdersPoIdPrintRouteImport } from './routes/_authenticated/purchase-orders.$poId.print'
import { Route as AuthenticatedRfqsRfqIdIndexRouteImport } from './routes/_authenticated/rfqs.$rfqId.index'
import { Route as AuthenticatedRfqsRfqIdPrintRouteImport } from './routes/_authenticated/rfqs.$rfqId.print'
import { Route as AuthenticatedWorkOrdersWoIdIndexRouteImport } from './routes/_authenticated/work-orders.$woId.index'
import { Route as AuthenticatedWorkOrdersWoIdPmExecutionRouteImport } from './routes/_authenticated/work-orders.$woId.pm-execution'
import { Route as AuthenticatedAssetsAssetIdTransferNewRouteImport } from './routes/_authenticated/assets.$assetId.transfer.new'
import { Route as AuthenticatedComplianceLicencesLicenceIdEditRouteImport } from './routes/_authenticated/compliance.licences.$licenceId.edit'
import { Route as AuthenticatedStoreIndentsIdAllocateItemIdRouteImport } from './routes/_authenticated/store-indents.$id.allocate.$itemId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorRouteRoute = VendorRouteRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorLoginRoute = VendorLoginRouteImport.update({
  id: '/vendor-login',
  path: '/vendor-login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAssetsRoute = AuthenticatedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAuditLogsRoute = AuthenticatedAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAuditsRoute = AuthenticatedAuditsRouteImport.update({
  id: '/audits',
  path: '/audits',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCalibrationRoute =
  AuthenticatedCalibrationRouteImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedComplianceRoute = AuthenticatedComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCondemnationRoute =
  AuthenticatedCondemnationRouteImport.update({
    id: '/condemnation',
    path: '/condemnation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConfigurationRoute =
  AuthenticatedConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedContractsRoute = AuthenticatedContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDisposalsRoute = AuthenticatedDisposalsRouteImport.update({
  id: '/disposals',
  path: '/disposals',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFinanceRoute = AuthenticatedFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedGrnsRoute = AuthenticatedGrnsRouteImport.update({
  id: '/grns',
  path: '/grns',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedIndentsRoute = AuthenticatedIndentsRouteImport.update({
  id: '/indents',
  path: '/indents',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInsuranceRoute = AuthenticatedInsuranceRouteImport.update({
  id: '/insurance',
  path: '/insurance',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedIntegratedAssetsRoute =
  AuthenticatedIntegratedAssetsRouteImport.update({
    id: '/integrated-assets',
    path: '/integrated-assets',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryRoute = AuthenticatedInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMyAllocationsRoute =
  AuthenticatedMyAllocationsRouteImport.update({
    id: '/my-allocations',
    path: '/my-allocations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPreventiveMaintenanceRoute =
  AuthenticatedPreventiveMaintenanceRouteImport.update({
    id: '/preventive-maintenance',
    path: '/preventive-maintenance',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPurchaseOrdersRoute =
  AuthenticatedPurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPurchaseRequestsRoute =
  AuthenticatedPurchaseRequestsRouteImport.update({
    id: '/purchase-requests',
    path: '/purchase-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQuotationComparisonTemplatesRoute =
  AuthenticatedQuotationComparisonTemplatesRouteImport.update({
    id: '/quotation-comparison-templates',
    path: '/quotation-comparison-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQuotationTemplatesRoute =
  AuthenticatedQuotationTemplatesRouteImport.update({
    id: '/quotation-templates',
    path: '/quotation-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportBreakdownRoute =
  AuthenticatedReportBreakdownRouteImport.update({
    id: '/report-breakdown',
    path: '/report-breakdown',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRfqsRoute = AuthenticatedRfqsRouteImport.update({
  id: '/rfqs',
  path: '/rfqs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSparesRoute = AuthenticatedSparesRouteImport.update({
  id: '/spares',
  path: '/spares',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStoreIndentsRoute =
  AuthenticatedStoreIndentsRouteImport.update({
    id: '/store-indents',
    path: '/store-indents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketsRoute = AuthenticatedTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTransfersRoute = AuthenticatedTransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedWorkOrdersRoute = AuthenticatedWorkOrdersRouteImport.update({
  id: '/work-orders',
  path: '/work-orders',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AssetSplatRoute = AssetSplatRouteImport.update({
  id: '/asset/$',
  path: '/asset/$',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorIndexRoute = VendorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorProfileRoute = VendorProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => VendorRouteRoute,
} as any)
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAssetsImportRoute =
  AuthenticatedAssetsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAssetsNewRoute = AuthenticatedAssetsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedAssetsRoute,
} as any)
const AuthenticatedAssetsQrLabelsRoute =
  AuthenticatedAssetsQrLabelsRouteImport.update({
    id: '/qr-labels',
    path: '/qr-labels',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAuditsIndexRoute =
  AuthenticatedAuditsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAuditsRoute,
  } as any)
const AuthenticatedAuditsAuditIdRoute =
  AuthenticatedAuditsAuditIdRouteImport.update({
    id: '/$auditId',
    path: '/$auditId',
    getParentRoute: () => AuthenticatedAuditsRoute,
  } as any)
const AuthenticatedAuditsNewRoute = AuthenticatedAuditsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedAuditsRoute,
} as any)
const AuthenticatedCondemnationIndexRoute =
  AuthenticatedCondemnationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCondemnationRoute,
  } as any)
const AuthenticatedCondemnationIdRoute =
  AuthenticatedCondemnationIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedCondemnationRoute,
  } as any)
const AuthenticatedCondemnationNewRoute =
  AuthenticatedCondemnationNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedCondemnationRoute,
  } as any)
const AuthenticatedContractsIndexRoute =
  AuthenticatedContractsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContractsRoute,
  } as any)
const AuthenticatedContractsContractIdRoute =
  AuthenticatedContractsContractIdRouteImport.update({
    id: '/$contractId',
    path: '/$contractId',
    getParentRoute: () => AuthenticatedContractsRoute,
  } as any)
const AuthenticatedContractsNewRoute =
  AuthenticatedContractsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedContractsRoute,
  } as any)
const AuthenticatedDisposalsIndexRoute =
  AuthenticatedDisposalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDisposalsRoute,
  } as any)
const AuthenticatedDisposalsNewRoute =
  AuthenticatedDisposalsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedDisposalsRoute,
  } as any)
const AuthenticatedFinanceCapitalisationRoute =
  AuthenticatedFinanceCapitalisationRouteImport.update({
    id: '/capitalisation',
    path: '/capitalisation',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceDashboardRoute =
  AuthenticatedFinanceDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceDepreciationRoute =
  AuthenticatedFinanceDepreciationRouteImport.update({
    id: '/depreciation',
    path: '/depreciation',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceDepreciationLedgerRoute =
  AuthenticatedFinanceDepreciationLedgerRouteImport.update({
    id: '/depreciation-ledger',
    path: '/depreciation-ledger',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceDepreciationRulesRoute =
  AuthenticatedFinanceDepreciationRulesRouteImport.update({
    id: '/depreciation-rules',
    path: '/depreciation-rules',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceDepreciationScheduleRoute =
  AuthenticatedFinanceDepreciationScheduleRouteImport.update({
    id: '/depreciation-schedule',
    path: '/depreciation-schedule',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceDisposalsRoute =
  AuthenticatedFinanceDisposalsRouteImport.update({
    id: '/disposals',
    path: '/disposals',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceFixedAssetRegisterRoute =
  AuthenticatedFinanceFixedAssetRegisterRouteImport.update({
    id: '/fixed-asset-register',
    path: '/fixed-asset-register',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedGrnsIndexRoute = AuthenticatedGrnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedGrnsRoute,
} as any)
const AuthenticatedGrnsGrnIdRoute = AuthenticatedGrnsGrnIdRouteImport.update({
  id: '/$grnId',
  path: '/$grnId',
  getParentRoute: () => AuthenticatedGrnsRoute,
} as any)
const AuthenticatedGrnsNewRoute = AuthenticatedGrnsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedGrnsRoute,
} as any)
const AuthenticatedGrnsNewFromPoRoute =
  AuthenticatedGrnsNewFromPoRouteImport.update({
    id: '/new-from-po',
    path: '/new-from-po',
    getParentRoute: () => AuthenticatedGrnsRoute,
  } as any)
const AuthenticatedIndentsIndexRoute =
  AuthenticatedIndentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedIndentsRoute,
  } as any)
const AuthenticatedIndentsIndentIdRoute =
  AuthenticatedIndentsIndentIdRouteImport.update({
    id: '/$indentId',
    path: '/$indentId',
    getParentRoute: () => AuthenticatedIndentsRoute,
  } as any)
const AuthenticatedIndentsEditRoute =
  AuthenticatedIndentsEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedIndentsRoute,
  } as any)
const AuthenticatedIndentsNewRoute = AuthenticatedIndentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedIndentsRoute,
} as any)
const AuthenticatedInsuranceIndexRoute =
  AuthenticatedInsuranceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInsuranceRoute,
  } as any)
const AuthenticatedInsurancePolicyIdRoute =
  AuthenticatedInsurancePolicyIdRouteImport.update({
    id: '/$policyId',
    path: '/$policyId',
    getParentRoute: () => AuthenticatedInsuranceRoute,
  } as any)
const AuthenticatedInsuranceNewRoute =
  AuthenticatedInsuranceNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedInsuranceRoute,
  } as any)
const AuthenticatedPurchaseOrdersIndexRoute =
  AuthenticatedPurchaseOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPurchaseOrdersRoute,
  } as any)
const AuthenticatedPurchaseOrdersPoIdRoute =
  AuthenticatedPurchaseOrdersPoIdRouteImport.update({
    id: '/$poId',
    path: '/$poId',
    getParentRoute: () => AuthenticatedPurchaseOrdersRoute,
  } as any)
const AuthenticatedPurchaseOrdersNewRoute =
  AuthenticatedPurchaseOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPurchaseOrdersRoute,
  } as any)
const AuthenticatedQuotationComparisonTemplatesIndexRoute =
  AuthenticatedQuotationComparisonTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedQuotationComparisonTemplatesRoute,
  } as any)
const AuthenticatedQuotationComparisonTemplatesTemplateIdRoute =
  AuthenticatedQuotationComparisonTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthenticatedQuotationComparisonTemplatesRoute,
  } as any)
const AuthenticatedQuotationComparisonTemplatesNewRoute =
  AuthenticatedQuotationComparisonTemplatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedQuotationComparisonTemplatesRoute,
  } as any)
const AuthenticatedQuotationTemplatesIndexRoute =
  AuthenticatedQuotationTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedQuotationTemplatesRoute,
  } as any)
const AuthenticatedQuotationTemplatesTemplateIdRoute =
  AuthenticatedQuotationTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthenticatedQuotationTemplatesRoute,
  } as any)
const AuthenticatedQuotationTemplatesNewRoute =
  AuthenticatedQuotationTemplatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedQuotationTemplatesRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsReportIdRoute =
  AuthenticatedReportsReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAmcRegisterRoute =
  AuthenticatedReportsAmcRegisterRouteImport.update({
    id: '/amc-register',
    path: '/amc-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAssetHistoryRoute =
  AuthenticatedReportsAssetHistoryRouteImport.update({
    id: '/asset-history',
    path: '/asset-history',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAssetRegisterRoute =
  AuthenticatedReportsAssetRegisterRouteImport.update({
    id: '/asset-register',
    path: '/asset-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAssetReliabilityRoute =
  AuthenticatedReportsAssetReliabilityRouteImport.update({
    id: '/asset-reliability',
    path: '/asset-reliability',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAssetTicketHistoryRoute =
  AuthenticatedReportsAssetTicketHistoryRouteImport.update({
    id: '/asset-ticket-history',
    path: '/asset-ticket-history',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAssetTransferRegisterRoute =
  AuthenticatedReportsAssetTransferRegisterRouteImport.update({
    id: '/asset-transfer-register',
    path: '/asset-transfer-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAuditDiscrepanciesRoute =
  AuthenticatedReportsAuditDiscrepanciesRouteImport.update({
    id: '/audit-discrepancies',
    path: '/audit-discrepancies',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsBreakdownAnalysisRoute =
  AuthenticatedReportsBreakdownAnalysisRouteImport.update({
    id: '/breakdown-analysis',
    path: '/breakdown-analysis',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsCalibrationDueRoute =
  AuthenticatedReportsCalibrationDueRouteImport.update({
    id: '/calibration-due',
    path: '/calibration-due',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsCalibrationStatusRoute =
  AuthenticatedReportsCalibrationStatusRouteImport.update({
    id: '/calibration-status',
    path: '/calibration-status',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsCondemnationRegisterRoute =
  AuthenticatedReportsCondemnationRegisterRouteImport.update({
    id: '/condemnation-register',
    path: '/condemnation-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsCrossDepartmentTicketsRoute =
  AuthenticatedReportsCrossDepartmentTicketsRouteImport.update({
    id: '/cross-department-tickets',
    path: '/cross-department-tickets',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsDepartmentSpareUsageRoute =
  AuthenticatedReportsDepartmentSpareUsageRouteImport.update({
    id: '/department-spare-usage',
    path: '/department-spare-usage',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsDisposalRegisterRoute =
  AuthenticatedReportsDisposalRegisterRouteImport.update({
    id: '/disposal-register',
    path: '/disposal-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsDowntimeRoute =
  AuthenticatedReportsDowntimeRouteImport.update({
    id: '/downtime',
    path: '/downtime',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsEngineerPerformanceRoute =
  AuthenticatedReportsEngineerPerformanceRouteImport.update({
    id: '/engineer-performance',
    path: '/engineer-performance',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsFixedAssetRegisterRoute =
  AuthenticatedReportsFixedAssetRegisterRouteImport.update({
    id: '/fixed-asset-register',
    path: '/fixed-asset-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsGrnRegisterRoute =
  AuthenticatedReportsGrnRegisterRouteImport.update({
    id: '/grn-register',
    path: '/grn-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsInsuranceClaimsRoute =
  AuthenticatedReportsInsuranceClaimsRouteImport.update({
    id: '/insurance-claims',
    path: '/insurance-claims',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsInsuranceRegisterRoute =
  AuthenticatedReportsInsuranceRegisterRouteImport.update({
    id: '/insurance-register',
    path: '/insurance-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsLicenceComplianceRoute =
  AuthenticatedReportsLicenceComplianceRouteImport.update({
    id: '/licence-compliance',
    path: '/licence-compliance',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsLowStockSparesRoute =
  AuthenticatedReportsLowStockSparesRouteImport.update({
    id: '/low-stock-spares',
    path: '/low-stock-spares',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsNabhEvidenceRoute =
  AuthenticatedReportsNabhEvidenceRouteImport.update({
    id: '/nabh-evidence',
    path: '/nabh-evidence',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsOpenTicketsRoute =
  AuthenticatedReportsOpenTicketsRouteImport.update({
    id: '/open-tickets',
    path: '/open-tickets',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsPmComplianceRoute =
  AuthenticatedReportsPmComplianceRouteImport.update({
    id: '/pm-compliance',
    path: '/pm-compliance',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsPoRegisterRoute =
  AuthenticatedReportsPoRegisterRouteImport.update({
    id: '/po-register',
    path: '/po-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsProcurementCycleRoute =
  AuthenticatedReportsProcurementCycleRouteImport.update({
    id: '/procurement-cycle',
    path: '/procurement-cycle',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsRepeatedBreakdownAssetsRoute =
  AuthenticatedReportsRepeatedBreakdownAssetsRouteImport.update({
    id: '/repeated-breakdown-assets',
    path: '/repeated-breakdown-assets',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSpareConsumptionRoute =
  AuthenticatedReportsSpareConsumptionRouteImport.update({
    id: '/spare-consumption',
    path: '/spare-consumption',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSpareCostRoute =
  AuthenticatedReportsSpareCostRouteImport.update({
    id: '/spare-cost',
    path: '/spare-cost',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSpareMovementRegisterRoute =
  AuthenticatedReportsSpareMovementRegisterRouteImport.update({
    id: '/spare-movement-register',
    path: '/spare-movement-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSpareStockRegisterRoute =
  AuthenticatedReportsSpareStockRegisterRouteImport.update({
    id: '/spare-stock-register',
    path: '/spare-stock-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSpareStockReorderRoute =
  AuthenticatedReportsSpareStockReorderRouteImport.update({
    id: '/spare-stock-reorder',
    path: '/spare-stock-reorder',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSpareTransferRegisterRoute =
  AuthenticatedReportsSpareTransferRegisterRouteImport.update({
    id: '/spare-transfer-register',
    path: '/spare-transfer-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsTicketDepartmentBreakdownRoute =
  AuthenticatedReportsTicketDepartmentBreakdownRouteImport.update({
    id: '/ticket-department-breakdown',
    path: '/ticket-department-breakdown',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsTicketRegisterRoute =
  AuthenticatedReportsTicketRegisterRouteImport.update({
    id: '/ticket-register',
    path: '/ticket-register',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsTicketSlaBreachRoute =
  AuthenticatedReportsTicketSlaBreachRouteImport.update({
    id: '/ticket-sla-breach',
    path: '/ticket-sla-breach',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsTicketSpareUsageRoute =
  AuthenticatedReportsTicketSpareUsageRouteImport.update({
    id: '/ticket-spare-usage',
    path: '/ticket-spare-usage',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsUserAuditLogRoute =
  AuthenticatedReportsUserAuditLogRouteImport.update({
    id: '/user-audit-log',
    path: '/user-audit-log',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsVendorTicketsRoute =
  AuthenticatedReportsVendorTicketsRouteImport.update({
    id: '/vendor-tickets',
    path: '/vendor-tickets',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsWarrantyExpiryRoute =
  AuthenticatedReportsWarrantyExpiryRouteImport.update({
    id: '/warranty-expiry',
    path: '/warranty-expiry',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedRfqsIndexRoute = AuthenticatedRfqsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRfqsRoute,
} as any)
const AuthenticatedRfqsRfqIdRoute = AuthenticatedRfqsRfqIdRouteImport.update({
  id: '/$rfqId',
  path: '/$rfqId',
  getParentRoute: () => AuthenticatedRfqsRoute,
} as any)
const AuthenticatedRfqsNewRoute = AuthenticatedRfqsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedRfqsRoute,
} as any)
const AuthenticatedSparesIndexRoute =
  AuthenticatedSparesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSparesRoute,
  } as any)
const AuthenticatedSparesSpareIdRoute =
  AuthenticatedSparesSpareIdRouteImport.update({
    id: '/$spareId',
    path: '/$spareId',
    getParentRoute: () => AuthenticatedSparesRoute,
  } as any)
const AuthenticatedSparesNewRoute = AuthenticatedSparesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedSparesRoute,
} as any)
const AuthenticatedSparesTransfersRoute =
  AuthenticatedSparesTransfersRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AuthenticatedSparesRoute,
  } as any)
const AuthenticatedStoreIndentsIndexRoute =
  AuthenticatedStoreIndentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedStoreIndentsRoute,
  } as any)
const AuthenticatedStoreIndentsIdRoute =
  AuthenticatedStoreIndentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedStoreIndentsRoute,
  } as any)
const AuthenticatedStoreIndentsNewRoute =
  AuthenticatedStoreIndentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedStoreIndentsRoute,
  } as any)
const AuthenticatedTicketsIndexRoute =
  AuthenticatedTicketsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTicketsRoute,
  } as any)
const AuthenticatedTicketsTicketIdRoute =
  AuthenticatedTicketsTicketIdRouteImport.update({
    id: '/$ticketId',
    path: '/$ticketId',
    getParentRoute: () => AuthenticatedTicketsRoute,
  } as any)
const AuthenticatedTicketsNewRoute = AuthenticatedTicketsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedTicketsRoute,
} as any)
const AuthenticatedTransfersIndexRoute =
  AuthenticatedTransfersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTransfersRoute,
  } as any)
const AuthenticatedTransfersTransferIdRoute =
  AuthenticatedTransfersTransferIdRouteImport.update({
    id: '/$transferId',
    path: '/$transferId',
    getParentRoute: () => AuthenticatedTransfersRoute,
  } as any)
const AuthenticatedTransfersNewRoute =
  AuthenticatedTransfersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTransfersRoute,
  } as any)
const AuthenticatedWorkOrdersIndexRoute =
  AuthenticatedWorkOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkOrdersRoute,
  } as any)
const AuthenticatedWorkOrdersWoIdRoute =
  AuthenticatedWorkOrdersWoIdRouteImport.update({
    id: '/$woId',
    path: '/$woId',
    getParentRoute: () => AuthenticatedWorkOrdersRoute,
  } as any)
const AuthenticatedWorkOrdersNewRoute =
  AuthenticatedWorkOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkOrdersRoute,
  } as any)
const VendorGrnsIndexRoute = VendorGrnsIndexRouteImport.update({
  id: '/grns/',
  path: '/grns/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorPurchaseOrdersIndexRoute =
  VendorPurchaseOrdersIndexRouteImport.update({
    id: '/purchase-orders/',
    path: '/purchase-orders/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorPurchaseOrdersPoIdRoute =
  VendorPurchaseOrdersPoIdRouteImport.update({
    id: '/purchase-orders/$poId',
    path: '/purchase-orders/$poId',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRfqsIndexRoute = VendorRfqsIndexRouteImport.update({
  id: '/rfqs/',
  path: '/rfqs/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorRfqsRfqIdRoute = VendorRfqsRfqIdRouteImport.update({
  id: '/rfqs/$rfqId',
  path: '/rfqs/$rfqId',
  getParentRoute: () => VendorRouteRoute,
} as any)
const AuthenticatedAssetsAssetIdIndexRoute =
  AuthenticatedAssetsAssetIdIndexRouteImport.update({
    id: '/$assetId/',
    path: '/$assetId/',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAssetsAssetIdEditRoute =
  AuthenticatedAssetsAssetIdEditRouteImport.update({
    id: '/$assetId/edit',
    path: '/$assetId/edit',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAssetsAssetIdReportIssueRoute =
  AuthenticatedAssetsAssetIdReportIssueRouteImport.update({
    id: '/$assetId/report-issue',
    path: '/$assetId/report-issue',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAuditsAuditIdIndexRoute =
  AuthenticatedAuditsAuditIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAuditsAuditIdRoute,
  } as any)
const AuthenticatedAuditsAuditIdDiscrepanciesRoute =
  AuthenticatedAuditsAuditIdDiscrepanciesRouteImport.update({
    id: '/discrepancies',
    path: '/discrepancies',
    getParentRoute: () => AuthenticatedAuditsAuditIdRoute,
  } as any)
const AuthenticatedAuditsAuditIdExecuteRoute =
  AuthenticatedAuditsAuditIdExecuteRouteImport.update({
    id: '/execute',
    path: '/execute',
    getParentRoute: () => AuthenticatedAuditsAuditIdRoute,
  } as any)
const AuthenticatedAuditsAuditIdSignoffRoute =
  AuthenticatedAuditsAuditIdSignoffRouteImport.update({
    id: '/signoff',
    path: '/signoff',
    getParentRoute: () => AuthenticatedAuditsAuditIdRoute,
  } as any)
const AuthenticatedComplianceLicencesIndexRoute =
  AuthenticatedComplianceLicencesIndexRouteImport.update({
    id: '/licences/',
    path: '/licences/',
    getParentRoute: () => AuthenticatedComplianceRoute,
  } as any)
const AuthenticatedComplianceLicencesNewRoute =
  AuthenticatedComplianceLicencesNewRouteImport.update({
    id: '/licences/new',
    path: '/licences/new',
    getParentRoute: () => AuthenticatedComplianceRoute,
  } as any)
const AuthenticatedContractsContractIdIndexRoute =
  AuthenticatedContractsContractIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContractsContractIdRoute,
  } as any)
const AuthenticatedContractsContractIdEditRoute =
  AuthenticatedContractsContractIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedContractsContractIdRoute,
  } as any)
const AuthenticatedFinanceDepreciationRunIdRoute =
  AuthenticatedFinanceDepreciationRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthenticatedFinanceDepreciationRoute,
  } as any)
const AuthenticatedFinanceDepreciationNewRoute =
  AuthenticatedFinanceDepreciationNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedFinanceDepreciationRoute,
  } as any)
const AuthenticatedGrnsGrnIdIndexRoute =
  AuthenticatedGrnsGrnIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGrnsGrnIdRoute,
  } as any)
const AuthenticatedGrnsGrnIdGenerateAssetsRoute =
  AuthenticatedGrnsGrnIdGenerateAssetsRouteImport.update({
    id: '/generate-assets',
    path: '/generate-assets',
    getParentRoute: () => AuthenticatedGrnsGrnIdRoute,
  } as any)
const AuthenticatedIndentsIndentIdIndexRoute =
  AuthenticatedIndentsIndentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedIndentsIndentIdRoute,
  } as any)
const AuthenticatedIndentsIndentIdEditRoute =
  AuthenticatedIndentsIndentIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedIndentsIndentIdRoute,
  } as any)
const AuthenticatedPurchaseOrdersPoIdIndexRoute =
  AuthenticatedPurchaseOrdersPoIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPurchaseOrdersPoIdRoute,
  } as any)
const AuthenticatedPurchaseOrdersPoIdEditRoute =
  AuthenticatedPurchaseOrdersPoIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedPurchaseOrdersPoIdRoute,
  } as any)
const AuthenticatedPurchaseOrdersPoIdPrintRoute =
  AuthenticatedPurchaseOrdersPoIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AuthenticatedPurchaseOrdersPoIdRoute,
  } as any)
const AuthenticatedRfqsRfqIdIndexRoute =
  AuthenticatedRfqsRfqIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedRfqsRfqIdRoute,
  } as any)
const AuthenticatedRfqsRfqIdPrintRoute =
  AuthenticatedRfqsRfqIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AuthenticatedRfqsRfqIdRoute,
  } as any)
const AuthenticatedWorkOrdersWoIdIndexRoute =
  AuthenticatedWorkOrdersWoIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkOrdersWoIdRoute,
  } as any)
const AuthenticatedWorkOrdersWoIdPmExecutionRoute =
  AuthenticatedWorkOrdersWoIdPmExecutionRouteImport.update({
    id: '/pm-execution',
    path: '/pm-execution',
    getParentRoute: () => AuthenticatedWorkOrdersWoIdRoute,
  } as any)
const AuthenticatedAssetsAssetIdTransferNewRoute =
  AuthenticatedAssetsAssetIdTransferNewRouteImport.update({
    id: '/$assetId/transfer/new',
    path: '/$assetId/transfer/new',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedComplianceLicencesLicenceIdEditRoute =
  AuthenticatedComplianceLicencesLicenceIdEditRouteImport.update({
    id: '/licences/$licenceId/edit',
    path: '/licences/$licenceId/edit',
    getParentRoute: () => AuthenticatedComplianceRoute,
  } as any)
const AuthenticatedStoreIndentsIdAllocateItemIdRoute =
  AuthenticatedStoreIndentsIdAllocateItemIdRouteImport.update({
    id: '/allocate/$itemId',
    path: '/allocate/$itemId',
    getParentRoute: () => AuthenticatedStoreIndentsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/vendor': typeof VendorRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/vendor-login': typeof VendorLoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/assets': typeof AuthenticatedAssetsRouteWithChildren
  '/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/audits': typeof AuthenticatedAuditsRouteWithChildren
  '/calibration': typeof AuthenticatedCalibrationRoute
  '/compliance': typeof AuthenticatedComplianceRouteWithChildren
  '/condemnation': typeof AuthenticatedCondemnationRouteWithChildren
  '/configuration': typeof AuthenticatedConfigurationRoute
  '/contracts': typeof AuthenticatedContractsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/disposals': typeof AuthenticatedDisposalsRouteWithChildren
  '/finance': typeof AuthenticatedFinanceRouteWithChildren
  '/grns': typeof AuthenticatedGrnsRouteWithChildren
  '/indents': typeof AuthenticatedIndentsRouteWithChildren
  '/insurance': typeof AuthenticatedInsuranceRouteWithChildren
  '/integrated-assets': typeof AuthenticatedIntegratedAssetsRoute
  '/inventory': typeof AuthenticatedInventoryRoute
  '/my-allocations': typeof AuthenticatedMyAllocationsRoute
  '/preventive-maintenance': typeof AuthenticatedPreventiveMaintenanceRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersRouteWithChildren
  '/purchase-requests': typeof AuthenticatedPurchaseRequestsRoute
  '/quotation-comparison-templates': typeof AuthenticatedQuotationComparisonTemplatesRouteWithChildren
  '/quotation-templates': typeof AuthenticatedQuotationTemplatesRouteWithChildren
  '/report-breakdown': typeof AuthenticatedReportBreakdownRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/rfqs': typeof AuthenticatedRfqsRouteWithChildren
  '/spares': typeof AuthenticatedSparesRouteWithChildren
  '/store-indents': typeof AuthenticatedStoreIndentsRouteWithChildren
  '/tickets': typeof AuthenticatedTicketsRouteWithChildren
  '/transfers': typeof AuthenticatedTransfersRouteWithChildren
  '/work-orders': typeof AuthenticatedWorkOrdersRouteWithChildren
  '/asset/$': typeof AssetSplatRoute
  '/vendor/profile': typeof VendorProfileRoute
  '/vendor/': typeof VendorIndexRoute
  '/assets/import': typeof AuthenticatedAssetsImportRoute
  '/assets/new': typeof AuthenticatedAssetsNewRoute
  '/assets/qr-labels': typeof AuthenticatedAssetsQrLabelsRoute
  '/audits/$auditId': typeof AuthenticatedAuditsAuditIdRouteWithChildren
  '/audits/new': typeof AuthenticatedAuditsNewRoute
  '/condemnation/$id': typeof AuthenticatedCondemnationIdRoute
  '/condemnation/new': typeof AuthenticatedCondemnationNewRoute
  '/contracts/$contractId': typeof AuthenticatedContractsContractIdRouteWithChildren
  '/contracts/new': typeof AuthenticatedContractsNewRoute
  '/disposals/new': typeof AuthenticatedDisposalsNewRoute
  '/finance/capitalisation': typeof AuthenticatedFinanceCapitalisationRoute
  '/finance/dashboard': typeof AuthenticatedFinanceDashboardRoute
  '/finance/depreciation': typeof AuthenticatedFinanceDepreciationRouteWithChildren
  '/finance/depreciation-ledger': typeof AuthenticatedFinanceDepreciationLedgerRoute
  '/finance/depreciation-rules': typeof AuthenticatedFinanceDepreciationRulesRoute
  '/finance/depreciation-schedule': typeof AuthenticatedFinanceDepreciationScheduleRoute
  '/finance/disposals': typeof AuthenticatedFinanceDisposalsRoute
  '/finance/fixed-asset-register': typeof AuthenticatedFinanceFixedAssetRegisterRoute
  '/grns/$grnId': typeof AuthenticatedGrnsGrnIdRouteWithChildren
  '/grns/new': typeof AuthenticatedGrnsNewRoute
  '/grns/new-from-po': typeof AuthenticatedGrnsNewFromPoRoute
  '/indents/$indentId': typeof AuthenticatedIndentsIndentIdRouteWithChildren
  '/indents/edit': typeof AuthenticatedIndentsEditRoute
  '/indents/new': typeof AuthenticatedIndentsNewRoute
  '/insurance/$policyId': typeof AuthenticatedInsurancePolicyIdRoute
  '/insurance/new': typeof AuthenticatedInsuranceNewRoute
  '/purchase-orders/$poId': typeof AuthenticatedPurchaseOrdersPoIdRouteWithChildren
  '/purchase-orders/new': typeof AuthenticatedPurchaseOrdersNewRoute
  '/quotation-comparison-templates/$templateId': typeof AuthenticatedQuotationComparisonTemplatesTemplateIdRoute
  '/quotation-comparison-templates/new': typeof AuthenticatedQuotationComparisonTemplatesNewRoute
  '/quotation-templates/$templateId': typeof AuthenticatedQuotationTemplatesTemplateIdRoute
  '/quotation-templates/new': typeof AuthenticatedQuotationTemplatesNewRoute
  '/reports/$reportId': typeof AuthenticatedReportsReportIdRoute
  '/reports/amc-register': typeof AuthenticatedReportsAmcRegisterRoute
  '/reports/asset-history': typeof AuthenticatedReportsAssetHistoryRoute
  '/reports/asset-register': typeof AuthenticatedReportsAssetRegisterRoute
  '/reports/asset-reliability': typeof AuthenticatedReportsAssetReliabilityRoute
  '/reports/asset-ticket-history': typeof AuthenticatedReportsAssetTicketHistoryRoute
  '/reports/asset-transfer-register': typeof AuthenticatedReportsAssetTransferRegisterRoute
  '/reports/audit-discrepancies': typeof AuthenticatedReportsAuditDiscrepanciesRoute
  '/reports/breakdown-analysis': typeof AuthenticatedReportsBreakdownAnalysisRoute
  '/reports/calibration-due': typeof AuthenticatedReportsCalibrationDueRoute
  '/reports/calibration-status': typeof AuthenticatedReportsCalibrationStatusRoute
  '/reports/condemnation-register': typeof AuthenticatedReportsCondemnationRegisterRoute
  '/reports/cross-department-tickets': typeof AuthenticatedReportsCrossDepartmentTicketsRoute
  '/reports/department-spare-usage': typeof AuthenticatedReportsDepartmentSpareUsageRoute
  '/reports/disposal-register': typeof AuthenticatedReportsDisposalRegisterRoute
  '/reports/downtime': typeof AuthenticatedReportsDowntimeRoute
  '/reports/engineer-performance': typeof AuthenticatedReportsEngineerPerformanceRoute
  '/reports/fixed-asset-register': typeof AuthenticatedReportsFixedAssetRegisterRoute
  '/reports/grn-register': typeof AuthenticatedReportsGrnRegisterRoute
  '/reports/insurance-claims': typeof AuthenticatedReportsInsuranceClaimsRoute
  '/reports/insurance-register': typeof AuthenticatedReportsInsuranceRegisterRoute
  '/reports/licence-compliance': typeof AuthenticatedReportsLicenceComplianceRoute
  '/reports/low-stock-spares': typeof AuthenticatedReportsLowStockSparesRoute
  '/reports/nabh-evidence': typeof AuthenticatedReportsNabhEvidenceRoute
  '/reports/open-tickets': typeof AuthenticatedReportsOpenTicketsRoute
  '/reports/pm-compliance': typeof AuthenticatedReportsPmComplianceRoute
  '/reports/po-register': typeof AuthenticatedReportsPoRegisterRoute
  '/reports/procurement-cycle': typeof AuthenticatedReportsProcurementCycleRoute
  '/reports/repeated-breakdown-assets': typeof AuthenticatedReportsRepeatedBreakdownAssetsRoute
  '/reports/spare-consumption': typeof AuthenticatedReportsSpareConsumptionRoute
  '/reports/spare-cost': typeof AuthenticatedReportsSpareCostRoute
  '/reports/spare-movement-register': typeof AuthenticatedReportsSpareMovementRegisterRoute
  '/reports/spare-stock-register': typeof AuthenticatedReportsSpareStockRegisterRoute
  '/reports/spare-stock-reorder': typeof AuthenticatedReportsSpareStockReorderRoute
  '/reports/spare-transfer-register': typeof AuthenticatedReportsSpareTransferRegisterRoute
  '/reports/ticket-department-breakdown': typeof AuthenticatedReportsTicketDepartmentBreakdownRoute
  '/reports/ticket-register': typeof AuthenticatedReportsTicketRegisterRoute
  '/reports/ticket-sla-breach': typeof AuthenticatedReportsTicketSlaBreachRoute
  '/reports/ticket-spare-usage': typeof AuthenticatedReportsTicketSpareUsageRoute
  '/reports/user-audit-log': typeof AuthenticatedReportsUserAuditLogRoute
  '/reports/vendor-tickets': typeof AuthenticatedReportsVendorTicketsRoute
  '/reports/warranty-expiry': typeof AuthenticatedReportsWarrantyExpiryRoute
  '/rfqs/$rfqId': typeof AuthenticatedRfqsRfqIdRouteWithChildren
  '/rfqs/new': typeof AuthenticatedRfqsNewRoute
  '/spares/$spareId': typeof AuthenticatedSparesSpareIdRoute
  '/spares/new': typeof AuthenticatedSparesNewRoute
  '/spares/transfers': typeof AuthenticatedSparesTransfersRoute
  '/store-indents/$id': typeof AuthenticatedStoreIndentsIdRouteWithChildren
  '/store-indents/new': typeof AuthenticatedStoreIndentsNewRoute
  '/tickets/$ticketId': typeof AuthenticatedTicketsTicketIdRoute
  '/tickets/new': typeof AuthenticatedTicketsNewRoute
  '/transfers/$transferId': typeof AuthenticatedTransfersTransferIdRoute
  '/transfers/new': typeof AuthenticatedTransfersNewRoute
  '/work-orders/$woId': typeof AuthenticatedWorkOrdersWoIdRouteWithChildren
  '/work-orders/new': typeof AuthenticatedWorkOrdersNewRoute
  '/vendor/purchase-orders/$poId': typeof VendorPurchaseOrdersPoIdRoute
  '/vendor/rfqs/$rfqId': typeof VendorRfqsRfqIdRoute
  '/assets/': typeof AuthenticatedAssetsIndexRoute
  '/audits/': typeof AuthenticatedAuditsIndexRoute
  '/condemnation/': typeof AuthenticatedCondemnationIndexRoute
  '/contracts/': typeof AuthenticatedContractsIndexRoute
  '/disposals/': typeof AuthenticatedDisposalsIndexRoute
  '/grns/': typeof AuthenticatedGrnsIndexRoute
  '/indents/': typeof AuthenticatedIndentsIndexRoute
  '/insurance/': typeof AuthenticatedInsuranceIndexRoute
  '/purchase-orders/': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/quotation-comparison-templates/': typeof AuthenticatedQuotationComparisonTemplatesIndexRoute
  '/quotation-templates/': typeof AuthenticatedQuotationTemplatesIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/rfqs/': typeof AuthenticatedRfqsIndexRoute
  '/spares/': typeof AuthenticatedSparesIndexRoute
  '/store-indents/': typeof AuthenticatedStoreIndentsIndexRoute
  '/tickets/': typeof AuthenticatedTicketsIndexRoute
  '/transfers/': typeof AuthenticatedTransfersIndexRoute
  '/work-orders/': typeof AuthenticatedWorkOrdersIndexRoute
  '/vendor/grns/': typeof VendorGrnsIndexRoute
  '/vendor/purchase-orders/': typeof VendorPurchaseOrdersIndexRoute
  '/vendor/rfqs/': typeof VendorRfqsIndexRoute
  '/assets/$assetId/edit': typeof AuthenticatedAssetsAssetIdEditRoute
  '/assets/$assetId/report-issue': typeof AuthenticatedAssetsAssetIdReportIssueRoute
  '/audits/$auditId/discrepancies': typeof AuthenticatedAuditsAuditIdDiscrepanciesRoute
  '/audits/$auditId/execute': typeof AuthenticatedAuditsAuditIdExecuteRoute
  '/audits/$auditId/signoff': typeof AuthenticatedAuditsAuditIdSignoffRoute
  '/compliance/licences/new': typeof AuthenticatedComplianceLicencesNewRoute
  '/contracts/$contractId/edit': typeof AuthenticatedContractsContractIdEditRoute
  '/finance/depreciation/$runId': typeof AuthenticatedFinanceDepreciationRunIdRoute
  '/finance/depreciation/new': typeof AuthenticatedFinanceDepreciationNewRoute
  '/grns/$grnId/generate-assets': typeof AuthenticatedGrnsGrnIdGenerateAssetsRoute
  '/indents/$indentId/edit': typeof AuthenticatedIndentsIndentIdEditRoute
  '/purchase-orders/$poId/edit': typeof AuthenticatedPurchaseOrdersPoIdEditRoute
  '/purchase-orders/$poId/print': typeof AuthenticatedPurchaseOrdersPoIdPrintRoute
  '/rfqs/$rfqId/print': typeof AuthenticatedRfqsRfqIdPrintRoute
  '/work-orders/$woId/pm-execution': typeof AuthenticatedWorkOrdersWoIdPmExecutionRoute
  '/assets/$assetId/': typeof AuthenticatedAssetsAssetIdIndexRoute
  '/audits/$auditId/': typeof AuthenticatedAuditsAuditIdIndexRoute
  '/compliance/licences/': typeof AuthenticatedComplianceLicencesIndexRoute
  '/contracts/$contractId/': typeof AuthenticatedContractsContractIdIndexRoute
  '/grns/$grnId/': typeof AuthenticatedGrnsGrnIdIndexRoute
  '/indents/$indentId/': typeof AuthenticatedIndentsIndentIdIndexRoute
  '/purchase-orders/$poId/': typeof AuthenticatedPurchaseOrdersPoIdIndexRoute
  '/rfqs/$rfqId/': typeof AuthenticatedRfqsRfqIdIndexRoute
  '/work-orders/$woId/': typeof AuthenticatedWorkOrdersWoIdIndexRoute
  '/assets/$assetId/transfer/new': typeof AuthenticatedAssetsAssetIdTransferNewRoute
  '/compliance/licences/$licenceId/edit': typeof AuthenticatedComplianceLicencesLicenceIdEditRoute
  '/store-indents/$id/allocate/$itemId': typeof AuthenticatedStoreIndentsIdAllocateItemIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/vendor-login': typeof VendorLoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/calibration': typeof AuthenticatedCalibrationRoute
  '/compliance': typeof AuthenticatedComplianceRouteWithChildren
  '/configuration': typeof AuthenticatedConfigurationRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/finance': typeof AuthenticatedFinanceRouteWithChildren
  '/integrated-assets': typeof AuthenticatedIntegratedAssetsRoute
  '/inventory': typeof AuthenticatedInventoryRoute
  '/my-allocations': typeof AuthenticatedMyAllocationsRoute
  '/preventive-maintenance': typeof AuthenticatedPreventiveMaintenanceRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/purchase-requests': typeof AuthenticatedPurchaseRequestsRoute
  '/report-breakdown': typeof AuthenticatedReportBreakdownRoute
  '/asset/$': typeof AssetSplatRoute
  '/vendor/profile': typeof VendorProfileRoute
  '/vendor': typeof VendorIndexRoute
  '/assets/import': typeof AuthenticatedAssetsImportRoute
  '/assets/new': typeof AuthenticatedAssetsNewRoute
  '/assets/qr-labels': typeof AuthenticatedAssetsQrLabelsRoute
  '/audits/new': typeof AuthenticatedAuditsNewRoute
  '/condemnation/$id': typeof AuthenticatedCondemnationIdRoute
  '/condemnation/new': typeof AuthenticatedCondemnationNewRoute
  '/contracts/new': typeof AuthenticatedContractsNewRoute
  '/disposals/new': typeof AuthenticatedDisposalsNewRoute
  '/finance/capitalisation': typeof AuthenticatedFinanceCapitalisationRoute
  '/finance/dashboard': typeof AuthenticatedFinanceDashboardRoute
  '/finance/depreciation': typeof AuthenticatedFinanceDepreciationRouteWithChildren
  '/finance/depreciation-ledger': typeof AuthenticatedFinanceDepreciationLedgerRoute
  '/finance/depreciation-rules': typeof AuthenticatedFinanceDepreciationRulesRoute
  '/finance/depreciation-schedule': typeof AuthenticatedFinanceDepreciationScheduleRoute
  '/finance/disposals': typeof AuthenticatedFinanceDisposalsRoute
  '/finance/fixed-asset-register': typeof AuthenticatedFinanceFixedAssetRegisterRoute
  '/grns/new': typeof AuthenticatedGrnsNewRoute
  '/grns/new-from-po': typeof AuthenticatedGrnsNewFromPoRoute
  '/indents/edit': typeof AuthenticatedIndentsEditRoute
  '/indents/new': typeof AuthenticatedIndentsNewRoute
  '/insurance/$policyId': typeof AuthenticatedInsurancePolicyIdRoute
  '/insurance/new': typeof AuthenticatedInsuranceNewRoute
  '/purchase-orders/new': typeof AuthenticatedPurchaseOrdersNewRoute
  '/quotation-comparison-templates/$templateId': typeof AuthenticatedQuotationComparisonTemplatesTemplateIdRoute
  '/quotation-comparison-templates/new': typeof AuthenticatedQuotationComparisonTemplatesNewRoute
  '/quotation-templates/$templateId': typeof AuthenticatedQuotationTemplatesTemplateIdRoute
  '/quotation-templates/new': typeof AuthenticatedQuotationTemplatesNewRoute
  '/reports/$reportId': typeof AuthenticatedReportsReportIdRoute
  '/reports/amc-register': typeof AuthenticatedReportsAmcRegisterRoute
  '/reports/asset-history': typeof AuthenticatedReportsAssetHistoryRoute
  '/reports/asset-register': typeof AuthenticatedReportsAssetRegisterRoute
  '/reports/asset-reliability': typeof AuthenticatedReportsAssetReliabilityRoute
  '/reports/asset-ticket-history': typeof AuthenticatedReportsAssetTicketHistoryRoute
  '/reports/asset-transfer-register': typeof AuthenticatedReportsAssetTransferRegisterRoute
  '/reports/audit-discrepancies': typeof AuthenticatedReportsAuditDiscrepanciesRoute
  '/reports/breakdown-analysis': typeof AuthenticatedReportsBreakdownAnalysisRoute
  '/reports/calibration-due': typeof AuthenticatedReportsCalibrationDueRoute
  '/reports/calibration-status': typeof AuthenticatedReportsCalibrationStatusRoute
  '/reports/condemnation-register': typeof AuthenticatedReportsCondemnationRegisterRoute
  '/reports/cross-department-tickets': typeof AuthenticatedReportsCrossDepartmentTicketsRoute
  '/reports/department-spare-usage': typeof AuthenticatedReportsDepartmentSpareUsageRoute
  '/reports/disposal-register': typeof AuthenticatedReportsDisposalRegisterRoute
  '/reports/downtime': typeof AuthenticatedReportsDowntimeRoute
  '/reports/engineer-performance': typeof AuthenticatedReportsEngineerPerformanceRoute
  '/reports/fixed-asset-register': typeof AuthenticatedReportsFixedAssetRegisterRoute
  '/reports/grn-register': typeof AuthenticatedReportsGrnRegisterRoute
  '/reports/insurance-claims': typeof AuthenticatedReportsInsuranceClaimsRoute
  '/reports/insurance-register': typeof AuthenticatedReportsInsuranceRegisterRoute
  '/reports/licence-compliance': typeof AuthenticatedReportsLicenceComplianceRoute
  '/reports/low-stock-spares': typeof AuthenticatedReportsLowStockSparesRoute
  '/reports/nabh-evidence': typeof AuthenticatedReportsNabhEvidenceRoute
  '/reports/open-tickets': typeof AuthenticatedReportsOpenTicketsRoute
  '/reports/pm-compliance': typeof AuthenticatedReportsPmComplianceRoute
  '/reports/po-register': typeof AuthenticatedReportsPoRegisterRoute
  '/reports/procurement-cycle': typeof AuthenticatedReportsProcurementCycleRoute
  '/reports/repeated-breakdown-assets': typeof AuthenticatedReportsRepeatedBreakdownAssetsRoute
  '/reports/spare-consumption': typeof AuthenticatedReportsSpareConsumptionRoute
  '/reports/spare-cost': typeof AuthenticatedReportsSpareCostRoute
  '/reports/spare-movement-register': typeof AuthenticatedReportsSpareMovementRegisterRoute
  '/reports/spare-stock-register': typeof AuthenticatedReportsSpareStockRegisterRoute
  '/reports/spare-stock-reorder': typeof AuthenticatedReportsSpareStockReorderRoute
  '/reports/spare-transfer-register': typeof AuthenticatedReportsSpareTransferRegisterRoute
  '/reports/ticket-department-breakdown': typeof AuthenticatedReportsTicketDepartmentBreakdownRoute
  '/reports/ticket-register': typeof AuthenticatedReportsTicketRegisterRoute
  '/reports/ticket-sla-breach': typeof AuthenticatedReportsTicketSlaBreachRoute
  '/reports/ticket-spare-usage': typeof AuthenticatedReportsTicketSpareUsageRoute
  '/reports/user-audit-log': typeof AuthenticatedReportsUserAuditLogRoute
  '/reports/vendor-tickets': typeof AuthenticatedReportsVendorTicketsRoute
  '/reports/warranty-expiry': typeof AuthenticatedReportsWarrantyExpiryRoute
  '/rfqs/new': typeof AuthenticatedRfqsNewRoute
  '/spares/$spareId': typeof AuthenticatedSparesSpareIdRoute
  '/spares/new': typeof AuthenticatedSparesNewRoute
  '/spares/transfers': typeof AuthenticatedSparesTransfersRoute
  '/store-indents/$id': typeof AuthenticatedStoreIndentsIdRouteWithChildren
  '/store-indents/new': typeof AuthenticatedStoreIndentsNewRoute
  '/tickets/$ticketId': typeof AuthenticatedTicketsTicketIdRoute
  '/tickets/new': typeof AuthenticatedTicketsNewRoute
  '/transfers/$transferId': typeof AuthenticatedTransfersTransferIdRoute
  '/transfers/new': typeof AuthenticatedTransfersNewRoute
  '/work-orders/new': typeof AuthenticatedWorkOrdersNewRoute
  '/vendor/purchase-orders/$poId': typeof VendorPurchaseOrdersPoIdRoute
  '/vendor/rfqs/$rfqId': typeof VendorRfqsRfqIdRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/audits': typeof AuthenticatedAuditsIndexRoute
  '/condemnation': typeof AuthenticatedCondemnationIndexRoute
  '/contracts': typeof AuthenticatedContractsIndexRoute
  '/disposals': typeof AuthenticatedDisposalsIndexRoute
  '/grns': typeof AuthenticatedGrnsIndexRoute
  '/indents': typeof AuthenticatedIndentsIndexRoute
  '/insurance': typeof AuthenticatedInsuranceIndexRoute
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/quotation-comparison-templates': typeof AuthenticatedQuotationComparisonTemplatesIndexRoute
  '/quotation-templates': typeof AuthenticatedQuotationTemplatesIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/rfqs': typeof AuthenticatedRfqsIndexRoute
  '/spares': typeof AuthenticatedSparesIndexRoute
  '/store-indents': typeof AuthenticatedStoreIndentsIndexRoute
  '/tickets': typeof AuthenticatedTicketsIndexRoute
  '/transfers': typeof AuthenticatedTransfersIndexRoute
  '/work-orders': typeof AuthenticatedWorkOrdersIndexRoute
  '/vendor/grns': typeof VendorGrnsIndexRoute
  '/vendor/purchase-orders': typeof VendorPurchaseOrdersIndexRoute
  '/vendor/rfqs': typeof VendorRfqsIndexRoute
  '/assets/$assetId/edit': typeof AuthenticatedAssetsAssetIdEditRoute
  '/assets/$assetId/report-issue': typeof AuthenticatedAssetsAssetIdReportIssueRoute
  '/audits/$auditId/discrepancies': typeof AuthenticatedAuditsAuditIdDiscrepanciesRoute
  '/audits/$auditId/execute': typeof AuthenticatedAuditsAuditIdExecuteRoute
  '/audits/$auditId/signoff': typeof AuthenticatedAuditsAuditIdSignoffRoute
  '/compliance/licences/new': typeof AuthenticatedComplianceLicencesNewRoute
  '/contracts/$contractId/edit': typeof AuthenticatedContractsContractIdEditRoute
  '/finance/depreciation/$runId': typeof AuthenticatedFinanceDepreciationRunIdRoute
  '/finance/depreciation/new': typeof AuthenticatedFinanceDepreciationNewRoute
  '/grns/$grnId/generate-assets': typeof AuthenticatedGrnsGrnIdGenerateAssetsRoute
  '/indents/$indentId/edit': typeof AuthenticatedIndentsIndentIdEditRoute
  '/purchase-orders/$poId/edit': typeof AuthenticatedPurchaseOrdersPoIdEditRoute
  '/purchase-orders/$poId/print': typeof AuthenticatedPurchaseOrdersPoIdPrintRoute
  '/rfqs/$rfqId/print': typeof AuthenticatedRfqsRfqIdPrintRoute
  '/work-orders/$woId/pm-execution': typeof AuthenticatedWorkOrdersWoIdPmExecutionRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdIndexRoute
  '/audits/$auditId': typeof AuthenticatedAuditsAuditIdIndexRoute
  '/compliance/licences': typeof AuthenticatedComplianceLicencesIndexRoute
  '/contracts/$contractId': typeof AuthenticatedContractsContractIdIndexRoute
  '/grns/$grnId': typeof AuthenticatedGrnsGrnIdIndexRoute
  '/indents/$indentId': typeof AuthenticatedIndentsIndentIdIndexRoute
  '/purchase-orders/$poId': typeof AuthenticatedPurchaseOrdersPoIdIndexRoute
  '/rfqs/$rfqId': typeof AuthenticatedRfqsRfqIdIndexRoute
  '/work-orders/$woId': typeof AuthenticatedWorkOrdersWoIdIndexRoute
  '/assets/$assetId/transfer/new': typeof AuthenticatedAssetsAssetIdTransferNewRoute
  '/compliance/licences/$licenceId/edit': typeof AuthenticatedComplianceLicencesLicenceIdEditRoute
  '/store-indents/$id/allocate/$itemId': typeof AuthenticatedStoreIndentsIdAllocateItemIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/vendor': typeof VendorRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/vendor-login': typeof VendorLoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/assets': typeof AuthenticatedAssetsRouteWithChildren
  '/_authenticated/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/_authenticated/audits': typeof AuthenticatedAuditsRouteWithChildren
  '/_authenticated/calibration': typeof AuthenticatedCalibrationRoute
  '/_authenticated/compliance': typeof AuthenticatedComplianceRouteWithChildren
  '/_authenticated/condemnation': typeof AuthenticatedCondemnationRouteWithChildren
  '/_authenticated/configuration': typeof AuthenticatedConfigurationRoute
  '/_authenticated/contracts': typeof AuthenticatedContractsRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/disposals': typeof AuthenticatedDisposalsRouteWithChildren
  '/_authenticated/finance': typeof AuthenticatedFinanceRouteWithChildren
  '/_authenticated/grns': typeof AuthenticatedGrnsRouteWithChildren
  '/_authenticated/indents': typeof AuthenticatedIndentsRouteWithChildren
  '/_authenticated/insurance': typeof AuthenticatedInsuranceRouteWithChildren
  '/_authenticated/integrated-assets': typeof AuthenticatedIntegratedAssetsRoute
  '/_authenticated/inventory': typeof AuthenticatedInventoryRoute
  '/_authenticated/my-allocations': typeof AuthenticatedMyAllocationsRoute
  '/_authenticated/preventive-maintenance': typeof AuthenticatedPreventiveMaintenanceRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/purchase-orders': typeof AuthenticatedPurchaseOrdersRouteWithChildren
  '/_authenticated/purchase-requests': typeof AuthenticatedPurchaseRequestsRoute
  '/_authenticated/quotation-comparison-templates': typeof AuthenticatedQuotationComparisonTemplatesRouteWithChildren
  '/_authenticated/quotation-templates': typeof AuthenticatedQuotationTemplatesRouteWithChildren
  '/_authenticated/report-breakdown': typeof AuthenticatedReportBreakdownRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/rfqs': typeof AuthenticatedRfqsRouteWithChildren
  '/_authenticated/spares': typeof AuthenticatedSparesRouteWithChildren
  '/_authenticated/store-indents': typeof AuthenticatedStoreIndentsRouteWithChildren
  '/_authenticated/tickets': typeof AuthenticatedTicketsRouteWithChildren
  '/_authenticated/transfers': typeof AuthenticatedTransfersRouteWithChildren
  '/_authenticated/work-orders': typeof AuthenticatedWorkOrdersRouteWithChildren
  '/asset/$': typeof AssetSplatRoute
  '/vendor/profile': typeof VendorProfileRoute
  '/vendor/': typeof VendorIndexRoute
  '/_authenticated/assets/import': typeof AuthenticatedAssetsImportRoute
  '/_authenticated/assets/new': typeof AuthenticatedAssetsNewRoute
  '/_authenticated/assets/qr-labels': typeof AuthenticatedAssetsQrLabelsRoute
  '/_authenticated/audits/$auditId': typeof AuthenticatedAuditsAuditIdRouteWithChildren
  '/_authenticated/audits/new': typeof AuthenticatedAuditsNewRoute
  '/_authenticated/condemnation/$id': typeof AuthenticatedCondemnationIdRoute
  '/_authenticated/condemnation/new': typeof AuthenticatedCondemnationNewRoute
  '/_authenticated/contracts/$contractId': typeof AuthenticatedContractsContractIdRouteWithChildren
  '/_authenticated/contracts/new': typeof AuthenticatedContractsNewRoute
  '/_authenticated/disposals/new': typeof AuthenticatedDisposalsNewRoute
  '/_authenticated/finance/capitalisation': typeof AuthenticatedFinanceCapitalisationRoute
  '/_authenticated/finance/dashboard': typeof AuthenticatedFinanceDashboardRoute
  '/_authenticated/finance/depreciation': typeof AuthenticatedFinanceDepreciationRouteWithChildren
  '/_authenticated/finance/depreciation-ledger': typeof AuthenticatedFinanceDepreciationLedgerRoute
  '/_authenticated/finance/depreciation-rules': typeof AuthenticatedFinanceDepreciationRulesRoute
  '/_authenticated/finance/depreciation-schedule': typeof AuthenticatedFinanceDepreciationScheduleRoute
  '/_authenticated/finance/disposals': typeof AuthenticatedFinanceDisposalsRoute
  '/_authenticated/finance/fixed-asset-register': typeof AuthenticatedFinanceFixedAssetRegisterRoute
  '/_authenticated/grns/$grnId': typeof AuthenticatedGrnsGrnIdRouteWithChildren
  '/_authenticated/grns/new': typeof AuthenticatedGrnsNewRoute
  '/_authenticated/grns/new-from-po': typeof AuthenticatedGrnsNewFromPoRoute
  '/_authenticated/indents/$indentId': typeof AuthenticatedIndentsIndentIdRouteWithChildren
  '/_authenticated/indents/edit': typeof AuthenticatedIndentsEditRoute
  '/_authenticated/indents/new': typeof AuthenticatedIndentsNewRoute
  '/_authenticated/insurance/$policyId': typeof AuthenticatedInsurancePolicyIdRoute
  '/_authenticated/insurance/new': typeof AuthenticatedInsuranceNewRoute
  '/_authenticated/purchase-orders/$poId': typeof AuthenticatedPurchaseOrdersPoIdRouteWithChildren
  '/_authenticated/purchase-orders/new': typeof AuthenticatedPurchaseOrdersNewRoute
  '/_authenticated/quotation-comparison-templates/$templateId': typeof AuthenticatedQuotationComparisonTemplatesTemplateIdRoute
  '/_authenticated/quotation-comparison-templates/new': typeof AuthenticatedQuotationComparisonTemplatesNewRoute
  '/_authenticated/quotation-templates/$templateId': typeof AuthenticatedQuotationTemplatesTemplateIdRoute
  '/_authenticated/quotation-templates/new': typeof AuthenticatedQuotationTemplatesNewRoute
  '/_authenticated/reports/$reportId': typeof AuthenticatedReportsReportIdRoute
  '/_authenticated/reports/amc-register': typeof AuthenticatedReportsAmcRegisterRoute
  '/_authenticated/reports/asset-history': typeof AuthenticatedReportsAssetHistoryRoute
  '/_authenticated/reports/asset-register': typeof AuthenticatedReportsAssetRegisterRoute
  '/_authenticated/reports/asset-reliability': typeof AuthenticatedReportsAssetReliabilityRoute
  '/_authenticated/reports/asset-ticket-history': typeof AuthenticatedReportsAssetTicketHistoryRoute
  '/_authenticated/reports/asset-transfer-register': typeof AuthenticatedReportsAssetTransferRegisterRoute
  '/_authenticated/reports/audit-discrepancies': typeof AuthenticatedReportsAuditDiscrepanciesRoute
  '/_authenticated/reports/breakdown-analysis': typeof AuthenticatedReportsBreakdownAnalysisRoute
  '/_authenticated/reports/calibration-due': typeof AuthenticatedReportsCalibrationDueRoute
  '/_authenticated/reports/calibration-status': typeof AuthenticatedReportsCalibrationStatusRoute
  '/_authenticated/reports/condemnation-register': typeof AuthenticatedReportsCondemnationRegisterRoute
  '/_authenticated/reports/cross-department-tickets': typeof AuthenticatedReportsCrossDepartmentTicketsRoute
  '/_authenticated/reports/department-spare-usage': typeof AuthenticatedReportsDepartmentSpareUsageRoute
  '/_authenticated/reports/disposal-register': typeof AuthenticatedReportsDisposalRegisterRoute
  '/_authenticated/reports/downtime': typeof AuthenticatedReportsDowntimeRoute
  '/_authenticated/reports/engineer-performance': typeof AuthenticatedReportsEngineerPerformanceRoute
  '/_authenticated/reports/fixed-asset-register': typeof AuthenticatedReportsFixedAssetRegisterRoute
  '/_authenticated/reports/grn-register': typeof AuthenticatedReportsGrnRegisterRoute
  '/_authenticated/reports/insurance-claims': typeof AuthenticatedReportsInsuranceClaimsRoute
  '/_authenticated/reports/insurance-register': typeof AuthenticatedReportsInsuranceRegisterRoute
  '/_authenticated/reports/licence-compliance': typeof AuthenticatedReportsLicenceComplianceRoute
  '/_authenticated/reports/low-stock-spares': typeof AuthenticatedReportsLowStockSparesRoute
  '/_authenticated/reports/nabh-evidence': typeof AuthenticatedReportsNabhEvidenceRoute
  '/_authenticated/reports/open-tickets': typeof AuthenticatedReportsOpenTicketsRoute
  '/_authenticated/reports/pm-compliance': typeof AuthenticatedReportsPmComplianceRoute
  '/_authenticated/reports/po-register': typeof AuthenticatedReportsPoRegisterRoute
  '/_authenticated/reports/procurement-cycle': typeof AuthenticatedReportsProcurementCycleRoute
  '/_authenticated/reports/repeated-breakdown-assets': typeof AuthenticatedReportsRepeatedBreakdownAssetsRoute
  '/_authenticated/reports/spare-consumption': typeof AuthenticatedReportsSpareConsumptionRoute
  '/_authenticated/reports/spare-cost': typeof AuthenticatedReportsSpareCostRoute
  '/_authenticated/reports/spare-movement-register': typeof AuthenticatedReportsSpareMovementRegisterRoute
  '/_authenticated/reports/spare-stock-register': typeof AuthenticatedReportsSpareStockRegisterRoute
  '/_authenticated/reports/spare-stock-reorder': typeof AuthenticatedReportsSpareStockReorderRoute
  '/_authenticated/reports/spare-transfer-register': typeof AuthenticatedReportsSpareTransferRegisterRoute
  '/_authenticated/reports/ticket-department-breakdown': typeof AuthenticatedReportsTicketDepartmentBreakdownRoute
  '/_authenticated/reports/ticket-register': typeof AuthenticatedReportsTicketRegisterRoute
  '/_authenticated/reports/ticket-sla-breach': typeof AuthenticatedReportsTicketSlaBreachRoute
  '/_authenticated/reports/ticket-spare-usage': typeof AuthenticatedReportsTicketSpareUsageRoute
  '/_authenticated/reports/user-audit-log': typeof AuthenticatedReportsUserAuditLogRoute
  '/_authenticated/reports/vendor-tickets': typeof AuthenticatedReportsVendorTicketsRoute
  '/_authenticated/reports/warranty-expiry': typeof AuthenticatedReportsWarrantyExpiryRoute
  '/_authenticated/rfqs/$rfqId': typeof AuthenticatedRfqsRfqIdRouteWithChildren
  '/_authenticated/rfqs/new': typeof AuthenticatedRfqsNewRoute
  '/_authenticated/spares/$spareId': typeof AuthenticatedSparesSpareIdRoute
  '/_authenticated/spares/new': typeof AuthenticatedSparesNewRoute
  '/_authenticated/spares/transfers': typeof AuthenticatedSparesTransfersRoute
  '/_authenticated/store-indents/$id': typeof AuthenticatedStoreIndentsIdRouteWithChildren
  '/_authenticated/store-indents/new': typeof AuthenticatedStoreIndentsNewRoute
  '/_authenticated/tickets/$ticketId': typeof AuthenticatedTicketsTicketIdRoute
  '/_authenticated/tickets/new': typeof AuthenticatedTicketsNewRoute
  '/_authenticated/transfers/$transferId': typeof AuthenticatedTransfersTransferIdRoute
  '/_authenticated/transfers/new': typeof AuthenticatedTransfersNewRoute
  '/_authenticated/work-orders/$woId': typeof AuthenticatedWorkOrdersWoIdRouteWithChildren
  '/_authenticated/work-orders/new': typeof AuthenticatedWorkOrdersNewRoute
  '/vendor/purchase-orders/$poId': typeof VendorPurchaseOrdersPoIdRoute
  '/vendor/rfqs/$rfqId': typeof VendorRfqsRfqIdRoute
  '/_authenticated/assets/': typeof AuthenticatedAssetsIndexRoute
  '/_authenticated/audits/': typeof AuthenticatedAuditsIndexRoute
  '/_authenticated/condemnation/': typeof AuthenticatedCondemnationIndexRoute
  '/_authenticated/contracts/': typeof AuthenticatedContractsIndexRoute
  '/_authenticated/disposals/': typeof AuthenticatedDisposalsIndexRoute
  '/_authenticated/grns/': typeof AuthenticatedGrnsIndexRoute
  '/_authenticated/indents/': typeof AuthenticatedIndentsIndexRoute
  '/_authenticated/insurance/': typeof AuthenticatedInsuranceIndexRoute
  '/_authenticated/purchase-orders/': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/_authenticated/quotation-comparison-templates/': typeof AuthenticatedQuotationComparisonTemplatesIndexRoute
  '/_authenticated/quotation-templates/': typeof AuthenticatedQuotationTemplatesIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/rfqs/': typeof AuthenticatedRfqsIndexRoute
  '/_authenticated/spares/': typeof AuthenticatedSparesIndexRoute
  '/_authenticated/store-indents/': typeof AuthenticatedStoreIndentsIndexRoute
  '/_authenticated/tickets/': typeof AuthenticatedTicketsIndexRoute
  '/_authenticated/transfers/': typeof AuthenticatedTransfersIndexRoute
  '/_authenticated/work-orders/': typeof AuthenticatedWorkOrdersIndexRoute
  '/vendor/grns/': typeof VendorGrnsIndexRoute
  '/vendor/purchase-orders/': typeof VendorPurchaseOrdersIndexRoute
  '/vendor/rfqs/': typeof VendorRfqsIndexRoute
  '/_authenticated/assets/$assetId/edit': typeof AuthenticatedAssetsAssetIdEditRoute
  '/_authenticated/assets/$assetId/report-issue': typeof AuthenticatedAssetsAssetIdReportIssueRoute
  '/_authenticated/audits/$auditId/discrepancies': typeof AuthenticatedAuditsAuditIdDiscrepanciesRoute
  '/_authenticated/audits/$auditId/execute': typeof AuthenticatedAuditsAuditIdExecuteRoute
  '/_authenticated/audits/$auditId/signoff': typeof AuthenticatedAuditsAuditIdSignoffRoute
  '/_authenticated/compliance/licences/new': typeof AuthenticatedComplianceLicencesNewRoute
  '/_authenticated/contracts/$contractId/edit': typeof AuthenticatedContractsContractIdEditRoute
  '/_authenticated/finance/depreciation/$runId': typeof AuthenticatedFinanceDepreciationRunIdRoute
  '/_authenticated/finance/depreciation/new': typeof AuthenticatedFinanceDepreciationNewRoute
  '/_authenticated/grns/$grnId/generate-assets': typeof AuthenticatedGrnsGrnIdGenerateAssetsRoute
  '/_authenticated/indents/$indentId/edit': typeof AuthenticatedIndentsIndentIdEditRoute
  '/_authenticated/purchase-orders/$poId/edit': typeof AuthenticatedPurchaseOrdersPoIdEditRoute
  '/_authenticated/purchase-orders/$poId/print': typeof AuthenticatedPurchaseOrdersPoIdPrintRoute
  '/_authenticated/rfqs/$rfqId/print': typeof AuthenticatedRfqsRfqIdPrintRoute
  '/_authenticated/work-orders/$woId/pm-execution': typeof AuthenticatedWorkOrdersWoIdPmExecutionRoute
  '/_authenticated/assets/$assetId/': typeof AuthenticatedAssetsAssetIdIndexRoute
  '/_authenticated/audits/$auditId/': typeof AuthenticatedAuditsAuditIdIndexRoute
  '/_authenticated/compliance/licences/': typeof AuthenticatedComplianceLicencesIndexRoute
  '/_authenticated/contracts/$contractId/': typeof AuthenticatedContractsContractIdIndexRoute
  '/_authenticated/grns/$grnId/': typeof AuthenticatedGrnsGrnIdIndexRoute
  '/_authenticated/indents/$indentId/': typeof AuthenticatedIndentsIndentIdIndexRoute
  '/_authenticated/purchase-orders/$poId/': typeof AuthenticatedPurchaseOrdersPoIdIndexRoute
  '/_authenticated/rfqs/$rfqId/': typeof AuthenticatedRfqsRfqIdIndexRoute
  '/_authenticated/work-orders/$woId/': typeof AuthenticatedWorkOrdersWoIdIndexRoute
  '/_authenticated/assets/$assetId/transfer/new': typeof AuthenticatedAssetsAssetIdTransferNewRoute
  '/_authenticated/compliance/licences/$licenceId/edit': typeof AuthenticatedComplianceLicencesLicenceIdEditRoute
  '/_authenticated/store-indents/$id/allocate/$itemId': typeof AuthenticatedStoreIndentsIdAllocateItemIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/vendor'
    | '/auth'
    | '/change-password'
    | '/reset-password'
    | '/vendor-login'
    | '/admin'
    | '/assets'
    | '/audit-logs'
    | '/audits'
    | '/calibration'
    | '/compliance'
    | '/condemnation'
    | '/configuration'
    | '/contracts'
    | '/dashboard'
    | '/disposals'
    | '/finance'
    | '/grns'
    | '/indents'
    | '/insurance'
    | '/integrated-assets'
    | '/inventory'
    | '/my-allocations'
    | '/preventive-maintenance'
    | '/profile'
    | '/purchase-orders'
    | '/purchase-requests'
    | '/quotation-comparison-templates'
    | '/quotation-templates'
    | '/report-breakdown'
    | '/reports'
    | '/rfqs'
    | '/spares'
    | '/store-indents'
    | '/tickets'
    | '/transfers'
    | '/work-orders'
    | '/asset/$'
    | '/vendor/profile'
    | '/vendor/'
    | '/assets/import'
    | '/assets/new'
    | '/assets/qr-labels'
    | '/audits/$auditId'
    | '/audits/new'
    | '/condemnation/$id'
    | '/condemnation/new'
    | '/contracts/$contractId'
    | '/contracts/new'
    | '/disposals/new'
    | '/finance/capitalisation'
    | '/finance/dashboard'
    | '/finance/depreciation'
    | '/finance/depreciation-ledger'
    | '/finance/depreciation-rules'
    | '/finance/depreciation-schedule'
    | '/finance/disposals'
    | '/finance/fixed-asset-register'
    | '/grns/$grnId'
    | '/grns/new'
    | '/grns/new-from-po'
    | '/indents/$indentId'
    | '/indents/edit'
    | '/indents/new'
    | '/insurance/$policyId'
    | '/insurance/new'
    | '/purchase-orders/$poId'
    | '/purchase-orders/new'
    | '/quotation-comparison-templates/$templateId'
    | '/quotation-comparison-templates/new'
    | '/quotation-templates/$templateId'
    | '/quotation-templates/new'
    | '/reports/$reportId'
    | '/reports/amc-register'
    | '/reports/asset-history'
    | '/reports/asset-register'
    | '/reports/asset-reliability'
    | '/reports/asset-ticket-history'
    | '/reports/asset-transfer-register'
    | '/reports/audit-discrepancies'
    | '/reports/breakdown-analysis'
    | '/reports/calibration-due'
    | '/reports/calibration-status'
    | '/reports/condemnation-register'
    | '/reports/cross-department-tickets'
    | '/reports/department-spare-usage'
    | '/reports/disposal-register'
    | '/reports/downtime'
    | '/reports/engineer-performance'
    | '/reports/fixed-asset-register'
    | '/reports/grn-register'
    | '/reports/insurance-claims'
    | '/reports/insurance-register'
    | '/reports/licence-compliance'
    | '/reports/low-stock-spares'
    | '/reports/nabh-evidence'
    | '/reports/open-tickets'
    | '/reports/pm-compliance'
    | '/reports/po-register'
    | '/reports/procurement-cycle'
    | '/reports/repeated-breakdown-assets'
    | '/reports/spare-consumption'
    | '/reports/spare-cost'
    | '/reports/spare-movement-register'
    | '/reports/spare-stock-register'
    | '/reports/spare-stock-reorder'
    | '/reports/spare-transfer-register'
    | '/reports/ticket-department-breakdown'
    | '/reports/ticket-register'
    | '/reports/ticket-sla-breach'
    | '/reports/ticket-spare-usage'
    | '/reports/user-audit-log'
    | '/reports/vendor-tickets'
    | '/reports/warranty-expiry'
    | '/rfqs/$rfqId'
    | '/rfqs/new'
    | '/spares/$spareId'
    | '/spares/new'
    | '/spares/transfers'
    | '/store-indents/$id'
    | '/store-indents/new'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/transfers/$transferId'
    | '/transfers/new'
    | '/work-orders/$woId'
    | '/work-orders/new'
    | '/vendor/purchase-orders/$poId'
    | '/vendor/rfqs/$rfqId'
    | '/assets/'
    | '/audits/'
    | '/condemnation/'
    | '/contracts/'
    | '/disposals/'
    | '/grns/'
    | '/indents/'
    | '/insurance/'
    | '/purchase-orders/'
    | '/quotation-comparison-templates/'
    | '/quotation-templates/'
    | '/reports/'
    | '/rfqs/'
    | '/spares/'
    | '/store-indents/'
    | '/tickets/'
    | '/transfers/'
    | '/work-orders/'
    | '/vendor/grns/'
    | '/vendor/purchase-orders/'
    | '/vendor/rfqs/'
    | '/assets/$assetId/edit'
    | '/assets/$assetId/report-issue'
    | '/audits/$auditId/discrepancies'
    | '/audits/$auditId/execute'
    | '/audits/$auditId/signoff'
    | '/compliance/licences/new'
    | '/contracts/$contractId/edit'
    | '/finance/depreciation/$runId'
    | '/finance/depreciation/new'
    | '/grns/$grnId/generate-assets'
    | '/indents/$indentId/edit'
    | '/purchase-orders/$poId/edit'
    | '/purchase-orders/$poId/print'
    | '/rfqs/$rfqId/print'
    | '/work-orders/$woId/pm-execution'
    | '/assets/$assetId/'
    | '/audits/$auditId/'
    | '/compliance/licences/'
    | '/contracts/$contractId/'
    | '/grns/$grnId/'
    | '/indents/$indentId/'
    | '/purchase-orders/$poId/'
    | '/rfqs/$rfqId/'
    | '/work-orders/$woId/'
    | '/assets/$assetId/transfer/new'
    | '/compliance/licences/$licenceId/edit'
    | '/store-indents/$id/allocate/$itemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/change-password'
    | '/reset-password'
    | '/vendor-login'
    | '/admin'
    | '/audit-logs'
    | '/calibration'
    | '/compliance'
    | '/configuration'
    | '/dashboard'
    | '/finance'
    | '/integrated-assets'
    | '/inventory'
    | '/my-allocations'
    | '/preventive-maintenance'
    | '/profile'
    | '/purchase-requests'
    | '/report-breakdown'
    | '/asset/$'
    | '/vendor/profile'
    | '/vendor'
    | '/assets/import'
    | '/assets/new'
    | '/assets/qr-labels'
    | '/audits/new'
    | '/condemnation/$id'
    | '/condemnation/new'
    | '/contracts/new'
    | '/disposals/new'
    | '/finance/capitalisation'
    | '/finance/dashboard'
    | '/finance/depreciation'
    | '/finance/depreciation-ledger'
    | '/finance/depreciation-rules'
    | '/finance/depreciation-schedule'
    | '/finance/disposals'
    | '/finance/fixed-asset-register'
    | '/grns/new'
    | '/grns/new-from-po'
    | '/indents/edit'
    | '/indents/new'
    | '/insurance/$policyId'
    | '/insurance/new'
    | '/purchase-orders/new'
    | '/quotation-comparison-templates/$templateId'
    | '/quotation-comparison-templates/new'
    | '/quotation-templates/$templateId'
    | '/quotation-templates/new'
    | '/reports/$reportId'
    | '/reports/amc-register'
    | '/reports/asset-history'
    | '/reports/asset-register'
    | '/reports/asset-reliability'
    | '/reports/asset-ticket-history'
    | '/reports/asset-transfer-register'
    | '/reports/audit-discrepancies'
    | '/reports/breakdown-analysis'
    | '/reports/calibration-due'
    | '/reports/calibration-status'
    | '/reports/condemnation-register'
    | '/reports/cross-department-tickets'
    | '/reports/department-spare-usage'
    | '/reports/disposal-register'
    | '/reports/downtime'
    | '/reports/engineer-performance'
    | '/reports/fixed-asset-register'
    | '/reports/grn-register'
    | '/reports/insurance-claims'
    | '/reports/insurance-register'
    | '/reports/licence-compliance'
    | '/reports/low-stock-spares'
    | '/reports/nabh-evidence'
    | '/reports/open-tickets'
    | '/reports/pm-compliance'
    | '/reports/po-register'
    | '/reports/procurement-cycle'
    | '/reports/repeated-breakdown-assets'
    | '/reports/spare-consumption'
    | '/reports/spare-cost'
    | '/reports/spare-movement-register'
    | '/reports/spare-stock-register'
    | '/reports/spare-stock-reorder'
    | '/reports/spare-transfer-register'
    | '/reports/ticket-department-breakdown'
    | '/reports/ticket-register'
    | '/reports/ticket-sla-breach'
    | '/reports/ticket-spare-usage'
    | '/reports/user-audit-log'
    | '/reports/vendor-tickets'
    | '/reports/warranty-expiry'
    | '/rfqs/new'
    | '/spares/$spareId'
    | '/spares/new'
    | '/spares/transfers'
    | '/store-indents/$id'
    | '/store-indents/new'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/transfers/$transferId'
    | '/transfers/new'
    | '/work-orders/new'
    | '/vendor/purchase-orders/$poId'
    | '/vendor/rfqs/$rfqId'
    | '/assets'
    | '/audits'
    | '/condemnation'
    | '/contracts'
    | '/disposals'
    | '/grns'
    | '/indents'
    | '/insurance'
    | '/purchase-orders'
    | '/quotation-comparison-templates'
    | '/quotation-templates'
    | '/reports'
    | '/rfqs'
    | '/spares'
    | '/store-indents'
    | '/tickets'
    | '/transfers'
    | '/work-orders'
    | '/vendor/grns'
    | '/vendor/purchase-orders'
    | '/vendor/rfqs'
    | '/assets/$assetId/edit'
    | '/assets/$assetId/report-issue'
    | '/audits/$auditId/discrepancies'
    | '/audits/$auditId/execute'
    | '/audits/$auditId/signoff'
    | '/compliance/licences/new'
    | '/contracts/$contractId/edit'
    | '/finance/depreciation/$runId'
    | '/finance/depreciation/new'
    | '/grns/$grnId/generate-assets'
    | '/indents/$indentId/edit'
    | '/purchase-orders/$poId/edit'
    | '/purchase-orders/$poId/print'
    | '/rfqs/$rfqId/print'
    | '/work-orders/$woId/pm-execution'
    | '/assets/$assetId'
    | '/audits/$auditId'
    | '/compliance/licences'
    | '/contracts/$contractId'
    | '/grns/$grnId'
    | '/indents/$indentId'
    | '/purchase-orders/$poId'
    | '/rfqs/$rfqId'
    | '/work-orders/$woId'
    | '/assets/$assetId/transfer/new'
    | '/compliance/licences/$licenceId/edit'
    | '/store-indents/$id/allocate/$itemId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/vendor'
    | '/auth'
    | '/change-password'
    | '/reset-password'
    | '/vendor-login'
    | '/_authenticated/admin'
    | '/_authenticated/assets'
    | '/_authenticated/audit-logs'
    | '/_authenticated/audits'
    | '/_authenticated/calibration'
    | '/_authenticated/compliance'
    | '/_authenticated/condemnation'
    | '/_authenticated/configuration'
    | '/_authenticated/contracts'
    | '/_authenticated/dashboard'
    | '/_authenticated/disposals'
    | '/_authenticated/finance'
    | '/_authenticated/grns'
    | '/_authenticated/indents'
    | '/_authenticated/insurance'
    | '/_authenticated/integrated-assets'
    | '/_authenticated/inventory'
    | '/_authenticated/my-allocations'
    | '/_authenticated/preventive-maintenance'
    | '/_authenticated/profile'
    | '/_authenticated/purchase-orders'
    | '/_authenticated/purchase-requests'
    | '/_authenticated/quotation-comparison-templates'
    | '/_authenticated/quotation-templates'
    | '/_authenticated/report-breakdown'
    | '/_authenticated/reports'
    | '/_authenticated/rfqs'
    | '/_authenticated/spares'
    | '/_authenticated/store-indents'
    | '/_authenticated/tickets'
    | '/_authenticated/transfers'
    | '/_authenticated/work-orders'
    | '/asset/$'
    | '/vendor/profile'
    | '/vendor/'
    | '/_authenticated/assets/import'
    | '/_authenticated/assets/new'
    | '/_authenticated/assets/qr-labels'
    | '/_authenticated/audits/$auditId'
    | '/_authenticated/audits/new'
    | '/_authenticated/condemnation/$id'
    | '/_authenticated/condemnation/new'
    | '/_authenticated/contracts/$contractId'
    | '/_authenticated/contracts/new'
    | '/_authenticated/disposals/new'
    | '/_authenticated/finance/capitalisation'
    | '/_authenticated/finance/dashboard'
    | '/_authenticated/finance/depreciation'
    | '/_authenticated/finance/depreciation-ledger'
    | '/_authenticated/finance/depreciation-rules'
    | '/_authenticated/finance/depreciation-schedule'
    | '/_authenticated/finance/disposals'
    | '/_authenticated/finance/fixed-asset-register'
    | '/_authenticated/grns/$grnId'
    | '/_authenticated/grns/new'
    | '/_authenticated/grns/new-from-po'
    | '/_authenticated/indents/$indentId'
    | '/_authenticated/indents/edit'
    | '/_authenticated/indents/new'
    | '/_authenticated/insurance/$policyId'
    | '/_authenticated/insurance/new'
    | '/_authenticated/purchase-orders/$poId'
    | '/_authenticated/purchase-orders/new'
    | '/_authenticated/quotation-comparison-templates/$templateId'
    | '/_authenticated/quotation-comparison-templates/new'
    | '/_authenticated/quotation-templates/$templateId'
    | '/_authenticated/quotation-templates/new'
    | '/_authenticated/reports/$reportId'
    | '/_authenticated/reports/amc-register'
    | '/_authenticated/reports/asset-history'
    | '/_authenticated/reports/asset-register'
    | '/_authenticated/reports/asset-reliability'
    | '/_authenticated/reports/asset-ticket-history'
    | '/_authenticated/reports/asset-transfer-register'
    | '/_authenticated/reports/audit-discrepancies'
    | '/_authenticated/reports/breakdown-analysis'
    | '/_authenticated/reports/calibration-due'
    | '/_authenticated/reports/calibration-status'
    | '/_authenticated/reports/condemnation-register'
    | '/_authenticated/reports/cross-department-tickets'
    | '/_authenticated/reports/department-spare-usage'
    | '/_authenticated/reports/disposal-register'
    | '/_authenticated/reports/downtime'
    | '/_authenticated/reports/engineer-performance'
    | '/_authenticated/reports/fixed-asset-register'
    | '/_authenticated/reports/grn-register'
    | '/_authenticated/reports/insurance-claims'
    | '/_authenticated/reports/insurance-register'
    | '/_authenticated/reports/licence-compliance'
    | '/_authenticated/reports/low-stock-spares'
    | '/_authenticated/reports/nabh-evidence'
    | '/_authenticated/reports/open-tickets'
    | '/_authenticated/reports/pm-compliance'
    | '/_authenticated/reports/po-register'
    | '/_authenticated/reports/procurement-cycle'
    | '/_authenticated/reports/repeated-breakdown-assets'
    | '/_authenticated/reports/spare-consumption'
    | '/_authenticated/reports/spare-cost'
    | '/_authenticated/reports/spare-movement-register'
    | '/_authenticated/reports/spare-stock-register'
    | '/_authenticated/reports/spare-stock-reorder'
    | '/_authenticated/reports/spare-transfer-register'
    | '/_authenticated/reports/ticket-department-breakdown'
    | '/_authenticated/reports/ticket-register'
    | '/_authenticated/reports/ticket-sla-breach'
    | '/_authenticated/reports/ticket-spare-usage'
    | '/_authenticated/reports/user-audit-log'
    | '/_authenticated/reports/vendor-tickets'
    | '/_authenticated/reports/warranty-expiry'
    | '/_authenticated/rfqs/$rfqId'
    | '/_authenticated/rfqs/new'
    | '/_authenticated/spares/$spareId'
    | '/_authenticated/spares/new'
    | '/_authenticated/spares/transfers'
    | '/_authenticated/store-indents/$id'
    | '/_authenticated/store-indents/new'
    | '/_authenticated/tickets/$ticketId'
    | '/_authenticated/tickets/new'
    | '/_authenticated/transfers/$transferId'
    | '/_authenticated/transfers/new'
    | '/_authenticated/work-orders/$woId'
    | '/_authenticated/work-orders/new'
    | '/vendor/purchase-orders/$poId'
    | '/vendor/rfqs/$rfqId'
    | '/_authenticated/assets/'
    | '/_authenticated/audits/'
    | '/_authenticated/condemnation/'
    | '/_authenticated/contracts/'
    | '/_authenticated/disposals/'
    | '/_authenticated/grns/'
    | '/_authenticated/indents/'
    | '/_authenticated/insurance/'
    | '/_authenticated/purchase-orders/'
    | '/_authenticated/quotation-comparison-templates/'
    | '/_authenticated/quotation-templates/'
    | '/_authenticated/reports/'
    | '/_authenticated/rfqs/'
    | '/_authenticated/spares/'
    | '/_authenticated/store-indents/'
    | '/_authenticated/tickets/'
    | '/_authenticated/transfers/'
    | '/_authenticated/work-orders/'
    | '/vendor/grns/'
    | '/vendor/purchase-orders/'
    | '/vendor/rfqs/'
    | '/_authenticated/assets/$assetId/edit'
    | '/_authenticated/assets/$assetId/report-issue'
    | '/_authenticated/audits/$auditId/discrepancies'
    | '/_authenticated/audits/$auditId/execute'
    | '/_authenticated/audits/$auditId/signoff'
    | '/_authenticated/compliance/licences/new'
    | '/_authenticated/contracts/$contractId/edit'
    | '/_authenticated/finance/depreciation/$runId'
    | '/_authenticated/finance/depreciation/new'
    | '/_authenticated/grns/$grnId/generate-assets'
    | '/_authenticated/indents/$indentId/edit'
    | '/_authenticated/purchase-orders/$poId/edit'
    | '/_authenticated/purchase-orders/$poId/print'
    | '/_authenticated/rfqs/$rfqId/print'
    | '/_authenticated/work-orders/$woId/pm-execution'
    | '/_authenticated/assets/$assetId/'
    | '/_authenticated/audits/$auditId/'
    | '/_authenticated/compliance/licences/'
    | '/_authenticated/contracts/$contractId/'
    | '/_authenticated/grns/$grnId/'
    | '/_authenticated/indents/$indentId/'
    | '/_authenticated/purchase-orders/$poId/'
    | '/_authenticated/rfqs/$rfqId/'
    | '/_authenticated/work-orders/$woId/'
    | '/_authenticated/assets/$assetId/transfer/new'
    | '/_authenticated/compliance/licences/$licenceId/edit'
    | '/_authenticated/store-indents/$id/allocate/$itemId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  VendorRouteRoute: typeof VendorRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VendorLoginRoute: typeof VendorLoginRoute
  AssetSplatRoute: typeof AssetSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor-login': {
      id: '/vendor-login'
      path: '/vendor-login'
      fullPath: '/vendor-login'
      preLoaderRoute: typeof VendorLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assets': {
      id: '/_authenticated/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audit-logs': {
      id: '/_authenticated/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuthenticatedAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audits': {
      id: '/_authenticated/audits'
      path: '/audits'
      fullPath: '/audits'
      preLoaderRoute: typeof AuthenticatedAuditsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/calibration': {
      id: '/_authenticated/calibration'
      path: '/calibration'
      fullPath: '/calibration'
      preLoaderRoute: typeof AuthenticatedCalibrationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/compliance': {
      id: '/_authenticated/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof AuthenticatedComplianceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/condemnation': {
      id: '/_authenticated/condemnation'
      path: '/condemnation'
      fullPath: '/condemnation'
      preLoaderRoute: typeof AuthenticatedCondemnationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/configuration': {
      id: '/_authenticated/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof AuthenticatedConfigurationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/contracts': {
      id: '/_authenticated/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof AuthenticatedContractsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/disposals': {
      id: '/_authenticated/disposals'
      path: '/disposals'
      fullPath: '/disposals'
      preLoaderRoute: typeof AuthenticatedDisposalsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/finance': {
      id: '/_authenticated/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AuthenticatedFinanceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/grns': {
      id: '/_authenticated/grns'
      path: '/grns'
      fullPath: '/grns'
      preLoaderRoute: typeof AuthenticatedGrnsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/indents': {
      id: '/_authenticated/indents'
      path: '/indents'
      fullPath: '/indents'
      preLoaderRoute: typeof AuthenticatedIndentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/insurance': {
      id: '/_authenticated/insurance'
      path: '/insurance'
      fullPath: '/insurance'
      preLoaderRoute: typeof AuthenticatedInsuranceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/integrated-assets': {
      id: '/_authenticated/integrated-assets'
      path: '/integrated-assets'
      fullPath: '/integrated-assets'
      preLoaderRoute: typeof AuthenticatedIntegratedAssetsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory': {
      id: '/_authenticated/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthenticatedInventoryRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-allocations': {
      id: '/_authenticated/my-allocations'
      path: '/my-allocations'
      fullPath: '/my-allocations'
      preLoaderRoute: typeof AuthenticatedMyAllocationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/preventive-maintenance': {
      id: '/_authenticated/preventive-maintenance'
      path: '/preventive-maintenance'
      fullPath: '/preventive-maintenance'
      preLoaderRoute: typeof AuthenticatedPreventiveMaintenanceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/purchase-orders': {
      id: '/_authenticated/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/purchase-orders'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/purchase-requests': {
      id: '/_authenticated/purchase-requests'
      path: '/purchase-requests'
      fullPath: '/purchase-requests'
      preLoaderRoute: typeof AuthenticatedPurchaseRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quotation-comparison-templates': {
      id: '/_authenticated/quotation-comparison-templates'
      path: '/quotation-comparison-templates'
      fullPath: '/quotation-comparison-templates'
      preLoaderRoute: typeof AuthenticatedQuotationComparisonTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quotation-templates': {
      id: '/_authenticated/quotation-templates'
      path: '/quotation-templates'
      fullPath: '/quotation-templates'
      preLoaderRoute: typeof AuthenticatedQuotationTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/report-breakdown': {
      id: '/_authenticated/report-breakdown'
      path: '/report-breakdown'
      fullPath: '/report-breakdown'
      preLoaderRoute: typeof AuthenticatedReportBreakdownRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/rfqs': {
      id: '/_authenticated/rfqs'
      path: '/rfqs'
      fullPath: '/rfqs'
      preLoaderRoute: typeof AuthenticatedRfqsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/spares': {
      id: '/_authenticated/spares'
      path: '/spares'
      fullPath: '/spares'
      preLoaderRoute: typeof AuthenticatedSparesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/store-indents': {
      id: '/_authenticated/store-indents'
      path: '/store-indents'
      fullPath: '/store-indents'
      preLoaderRoute: typeof AuthenticatedStoreIndentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tickets': {
      id: '/_authenticated/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AuthenticatedTicketsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/transfers': {
      id: '/_authenticated/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof AuthenticatedTransfersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/work-orders': {
      id: '/_authenticated/work-orders'
      path: '/work-orders'
      fullPath: '/work-orders'
      preLoaderRoute: typeof AuthenticatedWorkOrdersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/asset/$': {
      id: '/asset/$'
      path: '/asset/$'
      fullPath: '/asset/$'
      preLoaderRoute: typeof AssetSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/': {
      id: '/vendor/'
      path: '/'
      fullPath: '/vendor/'
      preLoaderRoute: typeof VendorIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/profile': {
      id: '/vendor/profile'
      path: '/profile'
      fullPath: '/vendor/profile'
      preLoaderRoute: typeof VendorProfileRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/_authenticated/assets/': {
      id: '/_authenticated/assets/'
      path: '/'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/import': {
      id: '/_authenticated/assets/import'
      path: '/import'
      fullPath: '/assets/import'
      preLoaderRoute: typeof AuthenticatedAssetsImportRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/new': {
      id: '/_authenticated/assets/new'
      path: '/new'
      fullPath: '/assets/new'
      preLoaderRoute: typeof AuthenticatedAssetsNewRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/qr-labels': {
      id: '/_authenticated/assets/qr-labels'
      path: '/qr-labels'
      fullPath: '/assets/qr-labels'
      preLoaderRoute: typeof AuthenticatedAssetsQrLabelsRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/audits/': {
      id: '/_authenticated/audits/'
      path: '/'
      fullPath: '/audits/'
      preLoaderRoute: typeof AuthenticatedAuditsIndexRouteImport
      parentRoute: typeof AuthenticatedAuditsRoute
    }
    '/_authenticated/audits/$auditId': {
      id: '/_authenticated/audits/$auditId'
      path: '/$auditId'
      fullPath: '/audits/$auditId'
      preLoaderRoute: typeof AuthenticatedAuditsAuditIdRouteImport
      parentRoute: typeof AuthenticatedAuditsRoute
    }
    '/_authenticated/audits/new': {
      id: '/_authenticated/audits/new'
      path: '/new'
      fullPath: '/audits/new'
      preLoaderRoute: typeof AuthenticatedAuditsNewRouteImport
      parentRoute: typeof AuthenticatedAuditsRoute
    }
    '/_authenticated/condemnation/': {
      id: '/_authenticated/condemnation/'
      path: '/'
      fullPath: '/condemnation/'
      preLoaderRoute: typeof AuthenticatedCondemnationIndexRouteImport
      parentRoute: typeof AuthenticatedCondemnationRoute
    }
    '/_authenticated/condemnation/$id': {
      id: '/_authenticated/condemnation/$id'
      path: '/$id'
      fullPath: '/condemnation/$id'
      preLoaderRoute: typeof AuthenticatedCondemnationIdRouteImport
      parentRoute: typeof AuthenticatedCondemnationRoute
    }
    '/_authenticated/condemnation/new': {
      id: '/_authenticated/condemnation/new'
      path: '/new'
      fullPath: '/condemnation/new'
      preLoaderRoute: typeof AuthenticatedCondemnationNewRouteImport
      parentRoute: typeof AuthenticatedCondemnationRoute
    }
    '/_authenticated/contracts/': {
      id: '/_authenticated/contracts/'
      path: '/'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AuthenticatedContractsIndexRouteImport
      parentRoute: typeof AuthenticatedContractsRoute
    }
    '/_authenticated/contracts/$contractId': {
      id: '/_authenticated/contracts/$contractId'
      path: '/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof AuthenticatedContractsContractIdRouteImport
      parentRoute: typeof AuthenticatedContractsRoute
    }
    '/_authenticated/contracts/new': {
      id: '/_authenticated/contracts/new'
      path: '/new'
      fullPath: '/contracts/new'
      preLoaderRoute: typeof AuthenticatedContractsNewRouteImport
      parentRoute: typeof AuthenticatedContractsRoute
    }
    '/_authenticated/disposals/': {
      id: '/_authenticated/disposals/'
      path: '/'
      fullPath: '/disposals/'
      preLoaderRoute: typeof AuthenticatedDisposalsIndexRouteImport
      parentRoute: typeof AuthenticatedDisposalsRoute
    }
    '/_authenticated/disposals/new': {
      id: '/_authenticated/disposals/new'
      path: '/new'
      fullPath: '/disposals/new'
      preLoaderRoute: typeof AuthenticatedDisposalsNewRouteImport
      parentRoute: typeof AuthenticatedDisposalsRoute
    }
    '/_authenticated/finance/capitalisation': {
      id: '/_authenticated/finance/capitalisation'
      path: '/capitalisation'
      fullPath: '/finance/capitalisation'
      preLoaderRoute: typeof AuthenticatedFinanceCapitalisationRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/dashboard': {
      id: '/_authenticated/finance/dashboard'
      path: '/dashboard'
      fullPath: '/finance/dashboard'
      preLoaderRoute: typeof AuthenticatedFinanceDashboardRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/depreciation': {
      id: '/_authenticated/finance/depreciation'
      path: '/depreciation'
      fullPath: '/finance/depreciation'
      preLoaderRoute: typeof AuthenticatedFinanceDepreciationRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/depreciation-ledger': {
      id: '/_authenticated/finance/depreciation-ledger'
      path: '/depreciation-ledger'
      fullPath: '/finance/depreciation-ledger'
      preLoaderRoute: typeof AuthenticatedFinanceDepreciationLedgerRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/depreciation-rules': {
      id: '/_authenticated/finance/depreciation-rules'
      path: '/depreciation-rules'
      fullPath: '/finance/depreciation-rules'
      preLoaderRoute: typeof AuthenticatedFinanceDepreciationRulesRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/depreciation-schedule': {
      id: '/_authenticated/finance/depreciation-schedule'
      path: '/depreciation-schedule'
      fullPath: '/finance/depreciation-schedule'
      preLoaderRoute: typeof AuthenticatedFinanceDepreciationScheduleRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/disposals': {
      id: '/_authenticated/finance/disposals'
      path: '/disposals'
      fullPath: '/finance/disposals'
      preLoaderRoute: typeof AuthenticatedFinanceDisposalsRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/fixed-asset-register': {
      id: '/_authenticated/finance/fixed-asset-register'
      path: '/fixed-asset-register'
      fullPath: '/finance/fixed-asset-register'
      preLoaderRoute: typeof AuthenticatedFinanceFixedAssetRegisterRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/grns/': {
      id: '/_authenticated/grns/'
      path: '/'
      fullPath: '/grns/'
      preLoaderRoute: typeof AuthenticatedGrnsIndexRouteImport
      parentRoute: typeof AuthenticatedGrnsRoute
    }
    '/_authenticated/grns/$grnId': {
      id: '/_authenticated/grns/$grnId'
      path: '/$grnId'
      fullPath: '/grns/$grnId'
      preLoaderRoute: typeof AuthenticatedGrnsGrnIdRouteImport
      parentRoute: typeof AuthenticatedGrnsRoute
    }
    '/_authenticated/grns/new': {
      id: '/_authenticated/grns/new'
      path: '/new'
      fullPath: '/grns/new'
      preLoaderRoute: typeof AuthenticatedGrnsNewRouteImport
      parentRoute: typeof AuthenticatedGrnsRoute
    }
    '/_authenticated/grns/new-from-po': {
      id: '/_authenticated/grns/new-from-po'
      path: '/new-from-po'
      fullPath: '/grns/new-from-po'
      preLoaderRoute: typeof AuthenticatedGrnsNewFromPoRouteImport
      parentRoute: typeof AuthenticatedGrnsRoute
    }
    '/_authenticated/indents/': {
      id: '/_authenticated/indents/'
      path: '/'
      fullPath: '/indents/'
      preLoaderRoute: typeof AuthenticatedIndentsIndexRouteImport
      parentRoute: typeof AuthenticatedIndentsRoute
    }
    '/_authenticated/indents/$indentId': {
      id: '/_authenticated/indents/$indentId'
      path: '/$indentId'
      fullPath: '/indents/$indentId'
      preLoaderRoute: typeof AuthenticatedIndentsIndentIdRouteImport
      parentRoute: typeof AuthenticatedIndentsRoute
    }
    '/_authenticated/indents/edit': {
      id: '/_authenticated/indents/edit'
      path: '/edit'
      fullPath: '/indents/edit'
      preLoaderRoute: typeof AuthenticatedIndentsEditRouteImport
      parentRoute: typeof AuthenticatedIndentsRoute
    }
    '/_authenticated/indents/new': {
      id: '/_authenticated/indents/new'
      path: '/new'
      fullPath: '/indents/new'
      preLoaderRoute: typeof AuthenticatedIndentsNewRouteImport
      parentRoute: typeof AuthenticatedIndentsRoute
    }
    '/_authenticated/insurance/': {
      id: '/_authenticated/insurance/'
      path: '/'
      fullPath: '/insurance/'
      preLoaderRoute: typeof AuthenticatedInsuranceIndexRouteImport
      parentRoute: typeof AuthenticatedInsuranceRoute
    }
    '/_authenticated/insurance/$policyId': {
      id: '/_authenticated/insurance/$policyId'
      path: '/$policyId'
      fullPath: '/insurance/$policyId'
      preLoaderRoute: typeof AuthenticatedInsurancePolicyIdRouteImport
      parentRoute: typeof AuthenticatedInsuranceRoute
    }
    '/_authenticated/insurance/new': {
      id: '/_authenticated/insurance/new'
      path: '/new'
      fullPath: '/insurance/new'
      preLoaderRoute: typeof AuthenticatedInsuranceNewRouteImport
      parentRoute: typeof AuthenticatedInsuranceRoute
    }
    '/_authenticated/purchase-orders/': {
      id: '/_authenticated/purchase-orders/'
      path: '/'
      fullPath: '/purchase-orders/'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersRoute
    }
    '/_authenticated/purchase-orders/$poId': {
      id: '/_authenticated/purchase-orders/$poId'
      path: '/$poId'
      fullPath: '/purchase-orders/$poId'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersPoIdRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersRoute
    }
    '/_authenticated/purchase-orders/new': {
      id: '/_authenticated/purchase-orders/new'
      path: '/new'
      fullPath: '/purchase-orders/new'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersNewRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersRoute
    }
    '/_authenticated/quotation-comparison-templates/': {
      id: '/_authenticated/quotation-comparison-templates/'
      path: '/'
      fullPath: '/quotation-comparison-templates/'
      preLoaderRoute: typeof AuthenticatedQuotationComparisonTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedQuotationComparisonTemplatesRoute
    }
    '/_authenticated/quotation-comparison-templates/$templateId': {
      id: '/_authenticated/quotation-comparison-templates/$templateId'
      path: '/$templateId'
      fullPath: '/quotation-comparison-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedQuotationComparisonTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedQuotationComparisonTemplatesRoute
    }
    '/_authenticated/quotation-comparison-templates/new': {
      id: '/_authenticated/quotation-comparison-templates/new'
      path: '/new'
      fullPath: '/quotation-comparison-templates/new'
      preLoaderRoute: typeof AuthenticatedQuotationComparisonTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedQuotationComparisonTemplatesRoute
    }
    '/_authenticated/quotation-templates/': {
      id: '/_authenticated/quotation-templates/'
      path: '/'
      fullPath: '/quotation-templates/'
      preLoaderRoute: typeof AuthenticatedQuotationTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedQuotationTemplatesRoute
    }
    '/_authenticated/quotation-templates/$templateId': {
      id: '/_authenticated/quotation-templates/$templateId'
      path: '/$templateId'
      fullPath: '/quotation-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedQuotationTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedQuotationTemplatesRoute
    }
    '/_authenticated/quotation-templates/new': {
      id: '/_authenticated/quotation-templates/new'
      path: '/new'
      fullPath: '/quotation-templates/new'
      preLoaderRoute: typeof AuthenticatedQuotationTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedQuotationTemplatesRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/$reportId': {
      id: '/_authenticated/reports/$reportId'
      path: '/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AuthenticatedReportsReportIdRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/amc-register': {
      id: '/_authenticated/reports/amc-register'
      path: '/amc-register'
      fullPath: '/reports/amc-register'
      preLoaderRoute: typeof AuthenticatedReportsAmcRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/asset-history': {
      id: '/_authenticated/reports/asset-history'
      path: '/asset-history'
      fullPath: '/reports/asset-history'
      preLoaderRoute: typeof AuthenticatedReportsAssetHistoryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/asset-register': {
      id: '/_authenticated/reports/asset-register'
      path: '/asset-register'
      fullPath: '/reports/asset-register'
      preLoaderRoute: typeof AuthenticatedReportsAssetRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/asset-reliability': {
      id: '/_authenticated/reports/asset-reliability'
      path: '/asset-reliability'
      fullPath: '/reports/asset-reliability'
      preLoaderRoute: typeof AuthenticatedReportsAssetReliabilityRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/asset-ticket-history': {
      id: '/_authenticated/reports/asset-ticket-history'
      path: '/asset-ticket-history'
      fullPath: '/reports/asset-ticket-history'
      preLoaderRoute: typeof AuthenticatedReportsAssetTicketHistoryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/asset-transfer-register': {
      id: '/_authenticated/reports/asset-transfer-register'
      path: '/asset-transfer-register'
      fullPath: '/reports/asset-transfer-register'
      preLoaderRoute: typeof AuthenticatedReportsAssetTransferRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/audit-discrepancies': {
      id: '/_authenticated/reports/audit-discrepancies'
      path: '/audit-discrepancies'
      fullPath: '/reports/audit-discrepancies'
      preLoaderRoute: typeof AuthenticatedReportsAuditDiscrepanciesRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/breakdown-analysis': {
      id: '/_authenticated/reports/breakdown-analysis'
      path: '/breakdown-analysis'
      fullPath: '/reports/breakdown-analysis'
      preLoaderRoute: typeof AuthenticatedReportsBreakdownAnalysisRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/calibration-due': {
      id: '/_authenticated/reports/calibration-due'
      path: '/calibration-due'
      fullPath: '/reports/calibration-due'
      preLoaderRoute: typeof AuthenticatedReportsCalibrationDueRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/calibration-status': {
      id: '/_authenticated/reports/calibration-status'
      path: '/calibration-status'
      fullPath: '/reports/calibration-status'
      preLoaderRoute: typeof AuthenticatedReportsCalibrationStatusRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/condemnation-register': {
      id: '/_authenticated/reports/condemnation-register'
      path: '/condemnation-register'
      fullPath: '/reports/condemnation-register'
      preLoaderRoute: typeof AuthenticatedReportsCondemnationRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/cross-department-tickets': {
      id: '/_authenticated/reports/cross-department-tickets'
      path: '/cross-department-tickets'
      fullPath: '/reports/cross-department-tickets'
      preLoaderRoute: typeof AuthenticatedReportsCrossDepartmentTicketsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/department-spare-usage': {
      id: '/_authenticated/reports/department-spare-usage'
      path: '/department-spare-usage'
      fullPath: '/reports/department-spare-usage'
      preLoaderRoute: typeof AuthenticatedReportsDepartmentSpareUsageRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/disposal-register': {
      id: '/_authenticated/reports/disposal-register'
      path: '/disposal-register'
      fullPath: '/reports/disposal-register'
      preLoaderRoute: typeof AuthenticatedReportsDisposalRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/downtime': {
      id: '/_authenticated/reports/downtime'
      path: '/downtime'
      fullPath: '/reports/downtime'
      preLoaderRoute: typeof AuthenticatedReportsDowntimeRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/engineer-performance': {
      id: '/_authenticated/reports/engineer-performance'
      path: '/engineer-performance'
      fullPath: '/reports/engineer-performance'
      preLoaderRoute: typeof AuthenticatedReportsEngineerPerformanceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/fixed-asset-register': {
      id: '/_authenticated/reports/fixed-asset-register'
      path: '/fixed-asset-register'
      fullPath: '/reports/fixed-asset-register'
      preLoaderRoute: typeof AuthenticatedReportsFixedAssetRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/grn-register': {
      id: '/_authenticated/reports/grn-register'
      path: '/grn-register'
      fullPath: '/reports/grn-register'
      preLoaderRoute: typeof AuthenticatedReportsGrnRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/insurance-claims': {
      id: '/_authenticated/reports/insurance-claims'
      path: '/insurance-claims'
      fullPath: '/reports/insurance-claims'
      preLoaderRoute: typeof AuthenticatedReportsInsuranceClaimsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/insurance-register': {
      id: '/_authenticated/reports/insurance-register'
      path: '/insurance-register'
      fullPath: '/reports/insurance-register'
      preLoaderRoute: typeof AuthenticatedReportsInsuranceRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/licence-compliance': {
      id: '/_authenticated/reports/licence-compliance'
      path: '/licence-compliance'
      fullPath: '/reports/licence-compliance'
      preLoaderRoute: typeof AuthenticatedReportsLicenceComplianceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/low-stock-spares': {
      id: '/_authenticated/reports/low-stock-spares'
      path: '/low-stock-spares'
      fullPath: '/reports/low-stock-spares'
      preLoaderRoute: typeof AuthenticatedReportsLowStockSparesRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/nabh-evidence': {
      id: '/_authenticated/reports/nabh-evidence'
      path: '/nabh-evidence'
      fullPath: '/reports/nabh-evidence'
      preLoaderRoute: typeof AuthenticatedReportsNabhEvidenceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/open-tickets': {
      id: '/_authenticated/reports/open-tickets'
      path: '/open-tickets'
      fullPath: '/reports/open-tickets'
      preLoaderRoute: typeof AuthenticatedReportsOpenTicketsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/pm-compliance': {
      id: '/_authenticated/reports/pm-compliance'
      path: '/pm-compliance'
      fullPath: '/reports/pm-compliance'
      preLoaderRoute: typeof AuthenticatedReportsPmComplianceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/po-register': {
      id: '/_authenticated/reports/po-register'
      path: '/po-register'
      fullPath: '/reports/po-register'
      preLoaderRoute: typeof AuthenticatedReportsPoRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/procurement-cycle': {
      id: '/_authenticated/reports/procurement-cycle'
      path: '/procurement-cycle'
      fullPath: '/reports/procurement-cycle'
      preLoaderRoute: typeof AuthenticatedReportsProcurementCycleRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/repeated-breakdown-assets': {
      id: '/_authenticated/reports/repeated-breakdown-assets'
      path: '/repeated-breakdown-assets'
      fullPath: '/reports/repeated-breakdown-assets'
      preLoaderRoute: typeof AuthenticatedReportsRepeatedBreakdownAssetsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/spare-consumption': {
      id: '/_authenticated/reports/spare-consumption'
      path: '/spare-consumption'
      fullPath: '/reports/spare-consumption'
      preLoaderRoute: typeof AuthenticatedReportsSpareConsumptionRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/spare-cost': {
      id: '/_authenticated/reports/spare-cost'
      path: '/spare-cost'
      fullPath: '/reports/spare-cost'
      preLoaderRoute: typeof AuthenticatedReportsSpareCostRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/spare-movement-register': {
      id: '/_authenticated/reports/spare-movement-register'
      path: '/spare-movement-register'
      fullPath: '/reports/spare-movement-register'
      preLoaderRoute: typeof AuthenticatedReportsSpareMovementRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/spare-stock-register': {
      id: '/_authenticated/reports/spare-stock-register'
      path: '/spare-stock-register'
      fullPath: '/reports/spare-stock-register'
      preLoaderRoute: typeof AuthenticatedReportsSpareStockRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/spare-stock-reorder': {
      id: '/_authenticated/reports/spare-stock-reorder'
      path: '/spare-stock-reorder'
      fullPath: '/reports/spare-stock-reorder'
      preLoaderRoute: typeof AuthenticatedReportsSpareStockReorderRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/spare-transfer-register': {
      id: '/_authenticated/reports/spare-transfer-register'
      path: '/spare-transfer-register'
      fullPath: '/reports/spare-transfer-register'
      preLoaderRoute: typeof AuthenticatedReportsSpareTransferRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/ticket-department-breakdown': {
      id: '/_authenticated/reports/ticket-department-breakdown'
      path: '/ticket-department-breakdown'
      fullPath: '/reports/ticket-department-breakdown'
      preLoaderRoute: typeof AuthenticatedReportsTicketDepartmentBreakdownRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/ticket-register': {
      id: '/_authenticated/reports/ticket-register'
      path: '/ticket-register'
      fullPath: '/reports/ticket-register'
      preLoaderRoute: typeof AuthenticatedReportsTicketRegisterRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/ticket-sla-breach': {
      id: '/_authenticated/reports/ticket-sla-breach'
      path: '/ticket-sla-breach'
      fullPath: '/reports/ticket-sla-breach'
      preLoaderRoute: typeof AuthenticatedReportsTicketSlaBreachRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/ticket-spare-usage': {
      id: '/_authenticated/reports/ticket-spare-usage'
      path: '/ticket-spare-usage'
      fullPath: '/reports/ticket-spare-usage'
      preLoaderRoute: typeof AuthenticatedReportsTicketSpareUsageRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/user-audit-log': {
      id: '/_authenticated/reports/user-audit-log'
      path: '/user-audit-log'
      fullPath: '/reports/user-audit-log'
      preLoaderRoute: typeof AuthenticatedReportsUserAuditLogRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/vendor-tickets': {
      id: '/_authenticated/reports/vendor-tickets'
      path: '/vendor-tickets'
      fullPath: '/reports/vendor-tickets'
      preLoaderRoute: typeof AuthenticatedReportsVendorTicketsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/warranty-expiry': {
      id: '/_authenticated/reports/warranty-expiry'
      path: '/warranty-expiry'
      fullPath: '/reports/warranty-expiry'
      preLoaderRoute: typeof AuthenticatedReportsWarrantyExpiryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/rfqs/': {
      id: '/_authenticated/rfqs/'
      path: '/'
      fullPath: '/rfqs/'
      preLoaderRoute: typeof AuthenticatedRfqsIndexRouteImport
      parentRoute: typeof AuthenticatedRfqsRoute
    }
    '/_authenticated/rfqs/$rfqId': {
      id: '/_authenticated/rfqs/$rfqId'
      path: '/$rfqId'
      fullPath: '/rfqs/$rfqId'
      preLoaderRoute: typeof AuthenticatedRfqsRfqIdRouteImport
      parentRoute: typeof AuthenticatedRfqsRoute
    }
    '/_authenticated/rfqs/new': {
      id: '/_authenticated/rfqs/new'
      path: '/new'
      fullPath: '/rfqs/new'
      preLoaderRoute: typeof AuthenticatedRfqsNewRouteImport
      parentRoute: typeof AuthenticatedRfqsRoute
    }
    '/_authenticated/spares/': {
      id: '/_authenticated/spares/'
      path: '/'
      fullPath: '/spares/'
      preLoaderRoute: typeof AuthenticatedSparesIndexRouteImport
      parentRoute: typeof AuthenticatedSparesRoute
    }
    '/_authenticated/spares/$spareId': {
      id: '/_authenticated/spares/$spareId'
      path: '/$spareId'
      fullPath: '/spares/$spareId'
      preLoaderRoute: typeof AuthenticatedSparesSpareIdRouteImport
      parentRoute: typeof AuthenticatedSparesRoute
    }
    '/_authenticated/spares/new': {
      id: '/_authenticated/spares/new'
      path: '/new'
      fullPath: '/spares/new'
      preLoaderRoute: typeof AuthenticatedSparesNewRouteImport
      parentRoute: typeof AuthenticatedSparesRoute
    }
    '/_authenticated/spares/transfers': {
      id: '/_authenticated/spares/transfers'
      path: '/transfers'
      fullPath: '/spares/transfers'
      preLoaderRoute: typeof AuthenticatedSparesTransfersRouteImport
      parentRoute: typeof AuthenticatedSparesRoute
    }
    '/_authenticated/store-indents/': {
      id: '/_authenticated/store-indents/'
      path: '/'
      fullPath: '/store-indents/'
      preLoaderRoute: typeof AuthenticatedStoreIndentsIndexRouteImport
      parentRoute: typeof AuthenticatedStoreIndentsRoute
    }
    '/_authenticated/store-indents/$id': {
      id: '/_authenticated/store-indents/$id'
      path: '/$id'
      fullPath: '/store-indents/$id'
      preLoaderRoute: typeof AuthenticatedStoreIndentsIdRouteImport
      parentRoute: typeof AuthenticatedStoreIndentsRoute
    }
    '/_authenticated/store-indents/new': {
      id: '/_authenticated/store-indents/new'
      path: '/new'
      fullPath: '/store-indents/new'
      preLoaderRoute: typeof AuthenticatedStoreIndentsNewRouteImport
      parentRoute: typeof AuthenticatedStoreIndentsRoute
    }
    '/_authenticated/tickets/': {
      id: '/_authenticated/tickets/'
      path: '/'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AuthenticatedTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedTicketsRoute
    }
    '/_authenticated/tickets/$ticketId': {
      id: '/_authenticated/tickets/$ticketId'
      path: '/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof AuthenticatedTicketsTicketIdRouteImport
      parentRoute: typeof AuthenticatedTicketsRoute
    }
    '/_authenticated/tickets/new': {
      id: '/_authenticated/tickets/new'
      path: '/new'
      fullPath: '/tickets/new'
      preLoaderRoute: typeof AuthenticatedTicketsNewRouteImport
      parentRoute: typeof AuthenticatedTicketsRoute
    }
    '/_authenticated/transfers/': {
      id: '/_authenticated/transfers/'
      path: '/'
      fullPath: '/transfers/'
      preLoaderRoute: typeof AuthenticatedTransfersIndexRouteImport
      parentRoute: typeof AuthenticatedTransfersRoute
    }
    '/_authenticated/transfers/$transferId': {
      id: '/_authenticated/transfers/$transferId'
      path: '/$transferId'
      fullPath: '/transfers/$transferId'
      preLoaderRoute: typeof AuthenticatedTransfersTransferIdRouteImport
      parentRoute: typeof AuthenticatedTransfersRoute
    }
    '/_authenticated/transfers/new': {
      id: '/_authenticated/transfers/new'
      path: '/new'
      fullPath: '/transfers/new'
      preLoaderRoute: typeof AuthenticatedTransfersNewRouteImport
      parentRoute: typeof AuthenticatedTransfersRoute
    }
    '/_authenticated/work-orders/': {
      id: '/_authenticated/work-orders/'
      path: '/'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersRoute
    }
    '/_authenticated/work-orders/$woId': {
      id: '/_authenticated/work-orders/$woId'
      path: '/$woId'
      fullPath: '/work-orders/$woId'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWoIdRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersRoute
    }
    '/_authenticated/work-orders/new': {
      id: '/_authenticated/work-orders/new'
      path: '/new'
      fullPath: '/work-orders/new'
      preLoaderRoute: typeof AuthenticatedWorkOrdersNewRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersRoute
    }
    '/vendor/grns/': {
      id: '/vendor/grns/'
      path: '/grns'
      fullPath: '/vendor/grns/'
      preLoaderRoute: typeof VendorGrnsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/purchase-orders/': {
      id: '/vendor/purchase-orders/'
      path: '/purchase-orders'
      fullPath: '/vendor/purchase-orders/'
      preLoaderRoute: typeof VendorPurchaseOrdersIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/purchase-orders/$poId': {
      id: '/vendor/purchase-orders/$poId'
      path: '/purchase-orders/$poId'
      fullPath: '/vendor/purchase-orders/$poId'
      preLoaderRoute: typeof VendorPurchaseOrdersPoIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rfqs/': {
      id: '/vendor/rfqs/'
      path: '/rfqs'
      fullPath: '/vendor/rfqs/'
      preLoaderRoute: typeof VendorRfqsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rfqs/$rfqId': {
      id: '/vendor/rfqs/$rfqId'
      path: '/rfqs/$rfqId'
      fullPath: '/vendor/rfqs/$rfqId'
      preLoaderRoute: typeof VendorRfqsRfqIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/_authenticated/assets/$assetId/': {
      id: '/_authenticated/assets/$assetId/'
      path: '/$assetId'
      fullPath: '/assets/$assetId/'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdIndexRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/$assetId/edit': {
      id: '/_authenticated/assets/$assetId/edit'
      path: '/$assetId/edit'
      fullPath: '/assets/$assetId/edit'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdEditRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/$assetId/report-issue': {
      id: '/_authenticated/assets/$assetId/report-issue'
      path: '/$assetId/report-issue'
      fullPath: '/assets/$assetId/report-issue'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdReportIssueRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/audits/$auditId/': {
      id: '/_authenticated/audits/$auditId/'
      path: '/'
      fullPath: '/audits/$auditId/'
      preLoaderRoute: typeof AuthenticatedAuditsAuditIdIndexRouteImport
      parentRoute: typeof AuthenticatedAuditsAuditIdRoute
    }
    '/_authenticated/audits/$auditId/discrepancies': {
      id: '/_authenticated/audits/$auditId/discrepancies'
      path: '/discrepancies'
      fullPath: '/audits/$auditId/discrepancies'
      preLoaderRoute: typeof AuthenticatedAuditsAuditIdDiscrepanciesRouteImport
      parentRoute: typeof AuthenticatedAuditsAuditIdRoute
    }
    '/_authenticated/audits/$auditId/execute': {
      id: '/_authenticated/audits/$auditId/execute'
      path: '/execute'
      fullPath: '/audits/$auditId/execute'
      preLoaderRoute: typeof AuthenticatedAuditsAuditIdExecuteRouteImport
      parentRoute: typeof AuthenticatedAuditsAuditIdRoute
    }
    '/_authenticated/audits/$auditId/signoff': {
      id: '/_authenticated/audits/$auditId/signoff'
      path: '/signoff'
      fullPath: '/audits/$auditId/signoff'
      preLoaderRoute: typeof AuthenticatedAuditsAuditIdSignoffRouteImport
      parentRoute: typeof AuthenticatedAuditsAuditIdRoute
    }
    '/_authenticated/compliance/licences/': {
      id: '/_authenticated/compliance/licences/'
      path: '/licences'
      fullPath: '/compliance/licences/'
      preLoaderRoute: typeof AuthenticatedComplianceLicencesIndexRouteImport
      parentRoute: typeof AuthenticatedComplianceRoute
    }
    '/_authenticated/compliance/licences/new': {
      id: '/_authenticated/compliance/licences/new'
      path: '/licences/new'
      fullPath: '/compliance/licences/new'
      preLoaderRoute: typeof AuthenticatedComplianceLicencesNewRouteImport
      parentRoute: typeof AuthenticatedComplianceRoute
    }
    '/_authenticated/contracts/$contractId/': {
      id: '/_authenticated/contracts/$contractId/'
      path: '/'
      fullPath: '/contracts/$contractId/'
      preLoaderRoute: typeof AuthenticatedContractsContractIdIndexRouteImport
      parentRoute: typeof AuthenticatedContractsContractIdRoute
    }
    '/_authenticated/contracts/$contractId/edit': {
      id: '/_authenticated/contracts/$contractId/edit'
      path: '/edit'
      fullPath: '/contracts/$contractId/edit'
      preLoaderRoute: typeof AuthenticatedContractsContractIdEditRouteImport
      parentRoute: typeof AuthenticatedContractsContractIdRoute
    }
    '/_authenticated/finance/depreciation/$runId': {
      id: '/_authenticated/finance/depreciation/$runId'
      path: '/$runId'
      fullPath: '/finance/depreciation/$runId'
      preLoaderRoute: typeof AuthenticatedFinanceDepreciationRunIdRouteImport
      parentRoute: typeof AuthenticatedFinanceDepreciationRoute
    }
    '/_authenticated/finance/depreciation/new': {
      id: '/_authenticated/finance/depreciation/new'
      path: '/new'
      fullPath: '/finance/depreciation/new'
      preLoaderRoute: typeof AuthenticatedFinanceDepreciationNewRouteImport
      parentRoute: typeof AuthenticatedFinanceDepreciationRoute
    }
    '/_authenticated/grns/$grnId/': {
      id: '/_authenticated/grns/$grnId/'
      path: '/'
      fullPath: '/grns/$grnId/'
      preLoaderRoute: typeof AuthenticatedGrnsGrnIdIndexRouteImport
      parentRoute: typeof AuthenticatedGrnsGrnIdRoute
    }
    '/_authenticated/grns/$grnId/generate-assets': {
      id: '/_authenticated/grns/$grnId/generate-assets'
      path: '/generate-assets'
      fullPath: '/grns/$grnId/generate-assets'
      preLoaderRoute: typeof AuthenticatedGrnsGrnIdGenerateAssetsRouteImport
      parentRoute: typeof AuthenticatedGrnsGrnIdRoute
    }
    '/_authenticated/indents/$indentId/': {
      id: '/_authenticated/indents/$indentId/'
      path: '/'
      fullPath: '/indents/$indentId/'
      preLoaderRoute: typeof AuthenticatedIndentsIndentIdIndexRouteImport
      parentRoute: typeof AuthenticatedIndentsIndentIdRoute
    }
    '/_authenticated/indents/$indentId/edit': {
      id: '/_authenticated/indents/$indentId/edit'
      path: '/edit'
      fullPath: '/indents/$indentId/edit'
      preLoaderRoute: typeof AuthenticatedIndentsIndentIdEditRouteImport
      parentRoute: typeof AuthenticatedIndentsIndentIdRoute
    }
    '/_authenticated/purchase-orders/$poId/': {
      id: '/_authenticated/purchase-orders/$poId/'
      path: '/'
      fullPath: '/purchase-orders/$poId/'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersPoIdIndexRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersPoIdRoute
    }
    '/_authenticated/purchase-orders/$poId/edit': {
      id: '/_authenticated/purchase-orders/$poId/edit'
      path: '/edit'
      fullPath: '/purchase-orders/$poId/edit'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersPoIdEditRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersPoIdRoute
    }
    '/_authenticated/purchase-orders/$poId/print': {
      id: '/_authenticated/purchase-orders/$poId/print'
      path: '/print'
      fullPath: '/purchase-orders/$poId/print'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersPoIdPrintRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersPoIdRoute
    }
    '/_authenticated/rfqs/$rfqId/': {
      id: '/_authenticated/rfqs/$rfqId/'
      path: '/'
      fullPath: '/rfqs/$rfqId/'
      preLoaderRoute: typeof AuthenticatedRfqsRfqIdIndexRouteImport
      parentRoute: typeof AuthenticatedRfqsRfqIdRoute
    }
    '/_authenticated/rfqs/$rfqId/print': {
      id: '/_authenticated/rfqs/$rfqId/print'
      path: '/print'
      fullPath: '/rfqs/$rfqId/print'
      preLoaderRoute: typeof AuthenticatedRfqsRfqIdPrintRouteImport
      parentRoute: typeof AuthenticatedRfqsRfqIdRoute
    }
    '/_authenticated/work-orders/$woId/': {
      id: '/_authenticated/work-orders/$woId/'
      path: '/'
      fullPath: '/work-orders/$woId/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWoIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWoIdRoute
    }
    '/_authenticated/work-orders/$woId/pm-execution': {
      id: '/_authenticated/work-orders/$woId/pm-execution'
      path: '/pm-execution'
      fullPath: '/work-orders/$woId/pm-execution'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWoIdPmExecutionRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersWoIdRoute
    }
    '/_authenticated/assets/$assetId/transfer/new': {
      id: '/_authenticated/assets/$assetId/transfer/new'
      path: '/$assetId/transfer/new'
      fullPath: '/assets/$assetId/transfer/new'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdTransferNewRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/compliance/licences/$licenceId/edit': {
      id: '/_authenticated/compliance/licences/$licenceId/edit'
      path: '/licences/$licenceId/edit'
      fullPath: '/compliance/licences/$licenceId/edit'
      preLoaderRoute: typeof AuthenticatedComplianceLicencesLicenceIdEditRouteImport
      parentRoute: typeof AuthenticatedComplianceRoute
    }
    '/_authenticated/store-indents/$id/allocate/$itemId': {
      id: '/_authenticated/store-indents/$id/allocate/$itemId'
      path: '/allocate/$itemId'
      fullPath: '/store-indents/$id/allocate/$itemId'
      preLoaderRoute: typeof AuthenticatedStoreIndentsIdAllocateItemIdRouteImport
      parentRoute: typeof AuthenticatedStoreIndentsIdRoute
    }
  }
}

interface AuthenticatedAssetsRouteChildren {
  AuthenticatedAssetsImportRoute: typeof AuthenticatedAssetsImportRoute
  AuthenticatedAssetsNewRoute: typeof AuthenticatedAssetsNewRoute
  AuthenticatedAssetsQrLabelsRoute: typeof AuthenticatedAssetsQrLabelsRoute
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute
  AuthenticatedAssetsAssetIdEditRoute: typeof AuthenticatedAssetsAssetIdEditRoute
  AuthenticatedAssetsAssetIdReportIssueRoute: typeof AuthenticatedAssetsAssetIdReportIssueRoute
  AuthenticatedAssetsAssetIdIndexRoute: typeof AuthenticatedAssetsAssetIdIndexRoute
  AuthenticatedAssetsAssetIdTransferNewRoute: typeof AuthenticatedAssetsAssetIdTransferNewRoute
}

const AuthenticatedAssetsRouteChildren: AuthenticatedAssetsRouteChildren = {
  AuthenticatedAssetsImportRoute: AuthenticatedAssetsImportRoute,
  AuthenticatedAssetsNewRoute: AuthenticatedAssetsNewRoute,
  AuthenticatedAssetsQrLabelsRoute: AuthenticatedAssetsQrLabelsRoute,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
  AuthenticatedAssetsAssetIdEditRoute: AuthenticatedAssetsAssetIdEditRoute,
  AuthenticatedAssetsAssetIdReportIssueRoute:
    AuthenticatedAssetsAssetIdReportIssueRoute,
  AuthenticatedAssetsAssetIdIndexRoute: AuthenticatedAssetsAssetIdIndexRoute,
  AuthenticatedAssetsAssetIdTransferNewRoute:
    AuthenticatedAssetsAssetIdTransferNewRoute,
}

const AuthenticatedAssetsRouteWithChildren =
  AuthenticatedAssetsRoute._addFileChildren(AuthenticatedAssetsRouteChildren)

interface AuthenticatedAuditsAuditIdRouteChildren {
  AuthenticatedAuditsAuditIdDiscrepanciesRoute: typeof AuthenticatedAuditsAuditIdDiscrepanciesRoute
  AuthenticatedAuditsAuditIdExecuteRoute: typeof AuthenticatedAuditsAuditIdExecuteRoute
  AuthenticatedAuditsAuditIdSignoffRoute: typeof AuthenticatedAuditsAuditIdSignoffRoute
  AuthenticatedAuditsAuditIdIndexRoute: typeof AuthenticatedAuditsAuditIdIndexRoute
}

const AuthenticatedAuditsAuditIdRouteChildren: AuthenticatedAuditsAuditIdRouteChildren =
  {
    AuthenticatedAuditsAuditIdDiscrepanciesRoute:
      AuthenticatedAuditsAuditIdDiscrepanciesRoute,
    AuthenticatedAuditsAuditIdExecuteRoute:
      AuthenticatedAuditsAuditIdExecuteRoute,
    AuthenticatedAuditsAuditIdSignoffRoute:
      AuthenticatedAuditsAuditIdSignoffRoute,
    AuthenticatedAuditsAuditIdIndexRoute: AuthenticatedAuditsAuditIdIndexRoute,
  }

const AuthenticatedAuditsAuditIdRouteWithChildren =
  AuthenticatedAuditsAuditIdRoute._addFileChildren(
    AuthenticatedAuditsAuditIdRouteChildren,
  )

interface AuthenticatedAuditsRouteChildren {
  AuthenticatedAuditsAuditIdRoute: typeof AuthenticatedAuditsAuditIdRouteWithChildren
  AuthenticatedAuditsNewRoute: typeof AuthenticatedAuditsNewRoute
  AuthenticatedAuditsIndexRoute: typeof AuthenticatedAuditsIndexRoute
}

const AuthenticatedAuditsRouteChildren: AuthenticatedAuditsRouteChildren = {
  AuthenticatedAuditsAuditIdRoute: AuthenticatedAuditsAuditIdRouteWithChildren,
  AuthenticatedAuditsNewRoute: AuthenticatedAuditsNewRoute,
  AuthenticatedAuditsIndexRoute: AuthenticatedAuditsIndexRoute,
}

const AuthenticatedAuditsRouteWithChildren =
  AuthenticatedAuditsRoute._addFileChildren(AuthenticatedAuditsRouteChildren)

interface AuthenticatedComplianceRouteChildren {
  AuthenticatedComplianceLicencesNewRoute: typeof AuthenticatedComplianceLicencesNewRoute
  AuthenticatedComplianceLicencesIndexRoute: typeof AuthenticatedComplianceLicencesIndexRoute
  AuthenticatedComplianceLicencesLicenceIdEditRoute: typeof AuthenticatedComplianceLicencesLicenceIdEditRoute
}

const AuthenticatedComplianceRouteChildren: AuthenticatedComplianceRouteChildren =
  {
    AuthenticatedComplianceLicencesNewRoute:
      AuthenticatedComplianceLicencesNewRoute,
    AuthenticatedComplianceLicencesIndexRoute:
      AuthenticatedComplianceLicencesIndexRoute,
    AuthenticatedComplianceLicencesLicenceIdEditRoute:
      AuthenticatedComplianceLicencesLicenceIdEditRoute,
  }

const AuthenticatedComplianceRouteWithChildren =
  AuthenticatedComplianceRoute._addFileChildren(
    AuthenticatedComplianceRouteChildren,
  )

interface AuthenticatedCondemnationRouteChildren {
  AuthenticatedCondemnationIdRoute: typeof AuthenticatedCondemnationIdRoute
  AuthenticatedCondemnationNewRoute: typeof AuthenticatedCondemnationNewRoute
  AuthenticatedCondemnationIndexRoute: typeof AuthenticatedCondemnationIndexRoute
}

const AuthenticatedCondemnationRouteChildren: AuthenticatedCondemnationRouteChildren =
  {
    AuthenticatedCondemnationIdRoute: AuthenticatedCondemnationIdRoute,
    AuthenticatedCondemnationNewRoute: AuthenticatedCondemnationNewRoute,
    AuthenticatedCondemnationIndexRoute: AuthenticatedCondemnationIndexRoute,
  }

const AuthenticatedCondemnationRouteWithChildren =
  AuthenticatedCondemnationRoute._addFileChildren(
    AuthenticatedCondemnationRouteChildren,
  )

interface AuthenticatedContractsContractIdRouteChildren {
  AuthenticatedContractsContractIdEditRoute: typeof AuthenticatedContractsContractIdEditRoute
  AuthenticatedContractsContractIdIndexRoute: typeof AuthenticatedContractsContractIdIndexRoute
}

const AuthenticatedContractsContractIdRouteChildren: AuthenticatedContractsContractIdRouteChildren =
  {
    AuthenticatedContractsContractIdEditRoute:
      AuthenticatedContractsContractIdEditRoute,
    AuthenticatedContractsContractIdIndexRoute:
      AuthenticatedContractsContractIdIndexRoute,
  }

const AuthenticatedContractsContractIdRouteWithChildren =
  AuthenticatedContractsContractIdRoute._addFileChildren(
    AuthenticatedContractsContractIdRouteChildren,
  )

interface AuthenticatedContractsRouteChildren {
  AuthenticatedContractsContractIdRoute: typeof AuthenticatedContractsContractIdRouteWithChildren
  AuthenticatedContractsNewRoute: typeof AuthenticatedContractsNewRoute
  AuthenticatedContractsIndexRoute: typeof AuthenticatedContractsIndexRoute
}

const AuthenticatedContractsRouteChildren: AuthenticatedContractsRouteChildren =
  {
    AuthenticatedContractsContractIdRoute:
      AuthenticatedContractsContractIdRouteWithChildren,
    AuthenticatedContractsNewRoute: AuthenticatedContractsNewRoute,
    AuthenticatedContractsIndexRoute: AuthenticatedContractsIndexRoute,
  }

const AuthenticatedContractsRouteWithChildren =
  AuthenticatedContractsRoute._addFileChildren(
    AuthenticatedContractsRouteChildren,
  )

interface AuthenticatedDisposalsRouteChildren {
  AuthenticatedDisposalsNewRoute: typeof AuthenticatedDisposalsNewRoute
  AuthenticatedDisposalsIndexRoute: typeof AuthenticatedDisposalsIndexRoute
}

const AuthenticatedDisposalsRouteChildren: AuthenticatedDisposalsRouteChildren =
  {
    AuthenticatedDisposalsNewRoute: AuthenticatedDisposalsNewRoute,
    AuthenticatedDisposalsIndexRoute: AuthenticatedDisposalsIndexRoute,
  }

const AuthenticatedDisposalsRouteWithChildren =
  AuthenticatedDisposalsRoute._addFileChildren(
    AuthenticatedDisposalsRouteChildren,
  )

interface AuthenticatedFinanceDepreciationRouteChildren {
  AuthenticatedFinanceDepreciationRunIdRoute: typeof AuthenticatedFinanceDepreciationRunIdRoute
  AuthenticatedFinanceDepreciationNewRoute: typeof AuthenticatedFinanceDepreciationNewRoute
}

const AuthenticatedFinanceDepreciationRouteChildren: AuthenticatedFinanceDepreciationRouteChildren =
  {
    AuthenticatedFinanceDepreciationRunIdRoute:
      AuthenticatedFinanceDepreciationRunIdRoute,
    AuthenticatedFinanceDepreciationNewRoute:
      AuthenticatedFinanceDepreciationNewRoute,
  }

const AuthenticatedFinanceDepreciationRouteWithChildren =
  AuthenticatedFinanceDepreciationRoute._addFileChildren(
    AuthenticatedFinanceDepreciationRouteChildren,
  )

interface AuthenticatedFinanceRouteChildren {
  AuthenticatedFinanceCapitalisationRoute: typeof AuthenticatedFinanceCapitalisationRoute
  AuthenticatedFinanceDashboardRoute: typeof AuthenticatedFinanceDashboardRoute
  AuthenticatedFinanceDepreciationRoute: typeof AuthenticatedFinanceDepreciationRouteWithChildren
  AuthenticatedFinanceDepreciationLedgerRoute: typeof AuthenticatedFinanceDepreciationLedgerRoute
  AuthenticatedFinanceDepreciationRulesRoute: typeof AuthenticatedFinanceDepreciationRulesRoute
  AuthenticatedFinanceDepreciationScheduleRoute: typeof AuthenticatedFinanceDepreciationScheduleRoute
  AuthenticatedFinanceDisposalsRoute: typeof AuthenticatedFinanceDisposalsRoute
  AuthenticatedFinanceFixedAssetRegisterRoute: typeof AuthenticatedFinanceFixedAssetRegisterRoute
}

const AuthenticatedFinanceRouteChildren: AuthenticatedFinanceRouteChildren = {
  AuthenticatedFinanceCapitalisationRoute:
    AuthenticatedFinanceCapitalisationRoute,
  AuthenticatedFinanceDashboardRoute: AuthenticatedFinanceDashboardRoute,
  AuthenticatedFinanceDepreciationRoute:
    AuthenticatedFinanceDepreciationRouteWithChildren,
  AuthenticatedFinanceDepreciationLedgerRoute:
    AuthenticatedFinanceDepreciationLedgerRoute,
  AuthenticatedFinanceDepreciationRulesRoute:
    AuthenticatedFinanceDepreciationRulesRoute,
  AuthenticatedFinanceDepreciationScheduleRoute:
    AuthenticatedFinanceDepreciationScheduleRoute,
  AuthenticatedFinanceDisposalsRoute: AuthenticatedFinanceDisposalsRoute,
  AuthenticatedFinanceFixedAssetRegisterRoute:
    AuthenticatedFinanceFixedAssetRegisterRoute,
}

const AuthenticatedFinanceRouteWithChildren =
  AuthenticatedFinanceRoute._addFileChildren(AuthenticatedFinanceRouteChildren)

interface AuthenticatedGrnsGrnIdRouteChildren {
  AuthenticatedGrnsGrnIdGenerateAssetsRoute: typeof AuthenticatedGrnsGrnIdGenerateAssetsRoute
  AuthenticatedGrnsGrnIdIndexRoute: typeof AuthenticatedGrnsGrnIdIndexRoute
}

const AuthenticatedGrnsGrnIdRouteChildren: AuthenticatedGrnsGrnIdRouteChildren =
  {
    AuthenticatedGrnsGrnIdGenerateAssetsRoute:
      AuthenticatedGrnsGrnIdGenerateAssetsRoute,
    AuthenticatedGrnsGrnIdIndexRoute: AuthenticatedGrnsGrnIdIndexRoute,
  }

const AuthenticatedGrnsGrnIdRouteWithChildren =
  AuthenticatedGrnsGrnIdRoute._addFileChildren(
    AuthenticatedGrnsGrnIdRouteChildren,
  )

interface AuthenticatedGrnsRouteChildren {
  AuthenticatedGrnsGrnIdRoute: typeof AuthenticatedGrnsGrnIdRouteWithChildren
  AuthenticatedGrnsNewRoute: typeof AuthenticatedGrnsNewRoute
  AuthenticatedGrnsNewFromPoRoute: typeof AuthenticatedGrnsNewFromPoRoute
  AuthenticatedGrnsIndexRoute: typeof AuthenticatedGrnsIndexRoute
}

const AuthenticatedGrnsRouteChildren: AuthenticatedGrnsRouteChildren = {
  AuthenticatedGrnsGrnIdRoute: AuthenticatedGrnsGrnIdRouteWithChildren,
  AuthenticatedGrnsNewRoute: AuthenticatedGrnsNewRoute,
  AuthenticatedGrnsNewFromPoRoute: AuthenticatedGrnsNewFromPoRoute,
  AuthenticatedGrnsIndexRoute: AuthenticatedGrnsIndexRoute,
}

const AuthenticatedGrnsRouteWithChildren =
  AuthenticatedGrnsRoute._addFileChildren(AuthenticatedGrnsRouteChildren)

interface AuthenticatedIndentsIndentIdRouteChildren {
  AuthenticatedIndentsIndentIdEditRoute: typeof AuthenticatedIndentsIndentIdEditRoute
  AuthenticatedIndentsIndentIdIndexRoute: typeof AuthenticatedIndentsIndentIdIndexRoute
}

const AuthenticatedIndentsIndentIdRouteChildren: AuthenticatedIndentsIndentIdRouteChildren =
  {
    AuthenticatedIndentsIndentIdEditRoute:
      AuthenticatedIndentsIndentIdEditRoute,
    AuthenticatedIndentsIndentIdIndexRoute:
      AuthenticatedIndentsIndentIdIndexRoute,
  }

const AuthenticatedIndentsIndentIdRouteWithChildren =
  AuthenticatedIndentsIndentIdRoute._addFileChildren(
    AuthenticatedIndentsIndentIdRouteChildren,
  )

interface AuthenticatedIndentsRouteChildren {
  AuthenticatedIndentsIndentIdRoute: typeof AuthenticatedIndentsIndentIdRouteWithChildren
  AuthenticatedIndentsEditRoute: typeof AuthenticatedIndentsEditRoute
  AuthenticatedIndentsNewRoute: typeof AuthenticatedIndentsNewRoute
  AuthenticatedIndentsIndexRoute: typeof AuthenticatedIndentsIndexRoute
}

const AuthenticatedIndentsRouteChildren: AuthenticatedIndentsRouteChildren = {
  AuthenticatedIndentsIndentIdRoute:
    AuthenticatedIndentsIndentIdRouteWithChildren,
  AuthenticatedIndentsEditRoute: AuthenticatedIndentsEditRoute,
  AuthenticatedIndentsNewRoute: AuthenticatedIndentsNewRoute,
  AuthenticatedIndentsIndexRoute: AuthenticatedIndentsIndexRoute,
}

const AuthenticatedIndentsRouteWithChildren =
  AuthenticatedIndentsRoute._addFileChildren(AuthenticatedIndentsRouteChildren)

interface AuthenticatedInsuranceRouteChildren {
  AuthenticatedInsurancePolicyIdRoute: typeof AuthenticatedInsurancePolicyIdRoute
  AuthenticatedInsuranceNewRoute: typeof AuthenticatedInsuranceNewRoute
  AuthenticatedInsuranceIndexRoute: typeof AuthenticatedInsuranceIndexRoute
}

const AuthenticatedInsuranceRouteChildren: AuthenticatedInsuranceRouteChildren =
  {
    AuthenticatedInsurancePolicyIdRoute: AuthenticatedInsurancePolicyIdRoute,
    AuthenticatedInsuranceNewRoute: AuthenticatedInsuranceNewRoute,
    AuthenticatedInsuranceIndexRoute: AuthenticatedInsuranceIndexRoute,
  }

const AuthenticatedInsuranceRouteWithChildren =
  AuthenticatedInsuranceRoute._addFileChildren(
    AuthenticatedInsuranceRouteChildren,
  )

interface AuthenticatedPurchaseOrdersPoIdRouteChildren {
  AuthenticatedPurchaseOrdersPoIdEditRoute: typeof AuthenticatedPurchaseOrdersPoIdEditRoute
  AuthenticatedPurchaseOrdersPoIdPrintRoute: typeof AuthenticatedPurchaseOrdersPoIdPrintRoute
  AuthenticatedPurchaseOrdersPoIdIndexRoute: typeof AuthenticatedPurchaseOrdersPoIdIndexRoute
}

const AuthenticatedPurchaseOrdersPoIdRouteChildren: AuthenticatedPurchaseOrdersPoIdRouteChildren =
  {
    AuthenticatedPurchaseOrdersPoIdEditRoute:
      AuthenticatedPurchaseOrdersPoIdEditRoute,
    AuthenticatedPurchaseOrdersPoIdPrintRoute:
      AuthenticatedPurchaseOrdersPoIdPrintRoute,
    AuthenticatedPurchaseOrdersPoIdIndexRoute:
      AuthenticatedPurchaseOrdersPoIdIndexRoute,
  }

const AuthenticatedPurchaseOrdersPoIdRouteWithChildren =
  AuthenticatedPurchaseOrdersPoIdRoute._addFileChildren(
    AuthenticatedPurchaseOrdersPoIdRouteChildren,
  )

interface AuthenticatedPurchaseOrdersRouteChildren {
  AuthenticatedPurchaseOrdersPoIdRoute: typeof AuthenticatedPurchaseOrdersPoIdRouteWithChildren
  AuthenticatedPurchaseOrdersNewRoute: typeof AuthenticatedPurchaseOrdersNewRoute
  AuthenticatedPurchaseOrdersIndexRoute: typeof AuthenticatedPurchaseOrdersIndexRoute
}

const AuthenticatedPurchaseOrdersRouteChildren: AuthenticatedPurchaseOrdersRouteChildren =
  {
    AuthenticatedPurchaseOrdersPoIdRoute:
      AuthenticatedPurchaseOrdersPoIdRouteWithChildren,
    AuthenticatedPurchaseOrdersNewRoute: AuthenticatedPurchaseOrdersNewRoute,
    AuthenticatedPurchaseOrdersIndexRoute:
      AuthenticatedPurchaseOrdersIndexRoute,
  }

const AuthenticatedPurchaseOrdersRouteWithChildren =
  AuthenticatedPurchaseOrdersRoute._addFileChildren(
    AuthenticatedPurchaseOrdersRouteChildren,
  )

interface AuthenticatedQuotationComparisonTemplatesRouteChildren {
  AuthenticatedQuotationComparisonTemplatesTemplateIdRoute: typeof AuthenticatedQuotationComparisonTemplatesTemplateIdRoute
  AuthenticatedQuotationComparisonTemplatesNewRoute: typeof AuthenticatedQuotationComparisonTemplatesNewRoute
  AuthenticatedQuotationComparisonTemplatesIndexRoute: typeof AuthenticatedQuotationComparisonTemplatesIndexRoute
}

const AuthenticatedQuotationComparisonTemplatesRouteChildren: AuthenticatedQuotationComparisonTemplatesRouteChildren =
  {
    AuthenticatedQuotationComparisonTemplatesTemplateIdRoute:
      AuthenticatedQuotationComparisonTemplatesTemplateIdRoute,
    AuthenticatedQuotationComparisonTemplatesNewRoute:
      AuthenticatedQuotationComparisonTemplatesNewRoute,
    AuthenticatedQuotationComparisonTemplatesIndexRoute:
      AuthenticatedQuotationComparisonTemplatesIndexRoute,
  }

const AuthenticatedQuotationComparisonTemplatesRouteWithChildren =
  AuthenticatedQuotationComparisonTemplatesRoute._addFileChildren(
    AuthenticatedQuotationComparisonTemplatesRouteChildren,
  )

interface AuthenticatedQuotationTemplatesRouteChildren {
  AuthenticatedQuotationTemplatesTemplateIdRoute: typeof AuthenticatedQuotationTemplatesTemplateIdRoute
  AuthenticatedQuotationTemplatesNewRoute: typeof AuthenticatedQuotationTemplatesNewRoute
  AuthenticatedQuotationTemplatesIndexRoute: typeof AuthenticatedQuotationTemplatesIndexRoute
}

const AuthenticatedQuotationTemplatesRouteChildren: AuthenticatedQuotationTemplatesRouteChildren =
  {
    AuthenticatedQuotationTemplatesTemplateIdRoute:
      AuthenticatedQuotationTemplatesTemplateIdRoute,
    AuthenticatedQuotationTemplatesNewRoute:
      AuthenticatedQuotationTemplatesNewRoute,
    AuthenticatedQuotationTemplatesIndexRoute:
      AuthenticatedQuotationTemplatesIndexRoute,
  }

const AuthenticatedQuotationTemplatesRouteWithChildren =
  AuthenticatedQuotationTemplatesRoute._addFileChildren(
    AuthenticatedQuotationTemplatesRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsReportIdRoute: typeof AuthenticatedReportsReportIdRoute
  AuthenticatedReportsAmcRegisterRoute: typeof AuthenticatedReportsAmcRegisterRoute
  AuthenticatedReportsAssetHistoryRoute: typeof AuthenticatedReportsAssetHistoryRoute
  AuthenticatedReportsAssetRegisterRoute: typeof AuthenticatedReportsAssetRegisterRoute
  AuthenticatedReportsAssetReliabilityRoute: typeof AuthenticatedReportsAssetReliabilityRoute
  AuthenticatedReportsAssetTicketHistoryRoute: typeof AuthenticatedReportsAssetTicketHistoryRoute
  AuthenticatedReportsAssetTransferRegisterRoute: typeof AuthenticatedReportsAssetTransferRegisterRoute
  AuthenticatedReportsAuditDiscrepanciesRoute: typeof AuthenticatedReportsAuditDiscrepanciesRoute
  AuthenticatedReportsBreakdownAnalysisRoute: typeof AuthenticatedReportsBreakdownAnalysisRoute
  AuthenticatedReportsCalibrationDueRoute: typeof AuthenticatedReportsCalibrationDueRoute
  AuthenticatedReportsCalibrationStatusRoute: typeof AuthenticatedReportsCalibrationStatusRoute
  AuthenticatedReportsCondemnationRegisterRoute: typeof AuthenticatedReportsCondemnationRegisterRoute
  AuthenticatedReportsCrossDepartmentTicketsRoute: typeof AuthenticatedReportsCrossDepartmentTicketsRoute
  AuthenticatedReportsDepartmentSpareUsageRoute: typeof AuthenticatedReportsDepartmentSpareUsageRoute
  AuthenticatedReportsDisposalRegisterRoute: typeof AuthenticatedReportsDisposalRegisterRoute
  AuthenticatedReportsDowntimeRoute: typeof AuthenticatedReportsDowntimeRoute
  AuthenticatedReportsEngineerPerformanceRoute: typeof AuthenticatedReportsEngineerPerformanceRoute
  AuthenticatedReportsFixedAssetRegisterRoute: typeof AuthenticatedReportsFixedAssetRegisterRoute
  AuthenticatedReportsGrnRegisterRoute: typeof AuthenticatedReportsGrnRegisterRoute
  AuthenticatedReportsInsuranceClaimsRoute: typeof AuthenticatedReportsInsuranceClaimsRoute
  AuthenticatedReportsInsuranceRegisterRoute: typeof AuthenticatedReportsInsuranceRegisterRoute
  AuthenticatedReportsLicenceComplianceRoute: typeof AuthenticatedReportsLicenceComplianceRoute
  AuthenticatedReportsLowStockSparesRoute: typeof AuthenticatedReportsLowStockSparesRoute
  AuthenticatedReportsNabhEvidenceRoute: typeof AuthenticatedReportsNabhEvidenceRoute
  AuthenticatedReportsOpenTicketsRoute: typeof AuthenticatedReportsOpenTicketsRoute
  AuthenticatedReportsPmComplianceRoute: typeof AuthenticatedReportsPmComplianceRoute
  AuthenticatedReportsPoRegisterRoute: typeof AuthenticatedReportsPoRegisterRoute
  AuthenticatedReportsProcurementCycleRoute: typeof AuthenticatedReportsProcurementCycleRoute
  AuthenticatedReportsRepeatedBreakdownAssetsRoute: typeof AuthenticatedReportsRepeatedBreakdownAssetsRoute
  AuthenticatedReportsSpareConsumptionRoute: typeof AuthenticatedReportsSpareConsumptionRoute
  AuthenticatedReportsSpareCostRoute: typeof AuthenticatedReportsSpareCostRoute
  AuthenticatedReportsSpareMovementRegisterRoute: typeof AuthenticatedReportsSpareMovementRegisterRoute
  AuthenticatedReportsSpareStockRegisterRoute: typeof AuthenticatedReportsSpareStockRegisterRoute
  AuthenticatedReportsSpareStockReorderRoute: typeof AuthenticatedReportsSpareStockReorderRoute
  AuthenticatedReportsSpareTransferRegisterRoute: typeof AuthenticatedReportsSpareTransferRegisterRoute
  AuthenticatedReportsTicketDepartmentBreakdownRoute: typeof AuthenticatedReportsTicketDepartmentBreakdownRoute
  AuthenticatedReportsTicketRegisterRoute: typeof AuthenticatedReportsTicketRegisterRoute
  AuthenticatedReportsTicketSlaBreachRoute: typeof AuthenticatedReportsTicketSlaBreachRoute
  AuthenticatedReportsTicketSpareUsageRoute: typeof AuthenticatedReportsTicketSpareUsageRoute
  AuthenticatedReportsUserAuditLogRoute: typeof AuthenticatedReportsUserAuditLogRoute
  AuthenticatedReportsVendorTicketsRoute: typeof AuthenticatedReportsVendorTicketsRoute
  AuthenticatedReportsWarrantyExpiryRoute: typeof AuthenticatedReportsWarrantyExpiryRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsReportIdRoute: AuthenticatedReportsReportIdRoute,
  AuthenticatedReportsAmcRegisterRoute: AuthenticatedReportsAmcRegisterRoute,
  AuthenticatedReportsAssetHistoryRoute: AuthenticatedReportsAssetHistoryRoute,
  AuthenticatedReportsAssetRegisterRoute:
    AuthenticatedReportsAssetRegisterRoute,
  AuthenticatedReportsAssetReliabilityRoute:
    AuthenticatedReportsAssetReliabilityRoute,
  AuthenticatedReportsAssetTicketHistoryRoute:
    AuthenticatedReportsAssetTicketHistoryRoute,
  AuthenticatedReportsAssetTransferRegisterRoute:
    AuthenticatedReportsAssetTransferRegisterRoute,
  AuthenticatedReportsAuditDiscrepanciesRoute:
    AuthenticatedReportsAuditDiscrepanciesRoute,
  AuthenticatedReportsBreakdownAnalysisRoute:
    AuthenticatedReportsBreakdownAnalysisRoute,
  AuthenticatedReportsCalibrationDueRoute:
    AuthenticatedReportsCalibrationDueRoute,
  AuthenticatedReportsCalibrationStatusRoute:
    AuthenticatedReportsCalibrationStatusRoute,
  AuthenticatedReportsCondemnationRegisterRoute:
    AuthenticatedReportsCondemnationRegisterRoute,
  AuthenticatedReportsCrossDepartmentTicketsRoute:
    AuthenticatedReportsCrossDepartmentTicketsRoute,
  AuthenticatedReportsDepartmentSpareUsageRoute:
    AuthenticatedReportsDepartmentSpareUsageRoute,
  AuthenticatedReportsDisposalRegisterRoute:
    AuthenticatedReportsDisposalRegisterRoute,
  AuthenticatedReportsDowntimeRoute: AuthenticatedReportsDowntimeRoute,
  AuthenticatedReportsEngineerPerformanceRoute:
    AuthenticatedReportsEngineerPerformanceRoute,
  AuthenticatedReportsFixedAssetRegisterRoute:
    AuthenticatedReportsFixedAssetRegisterRoute,
  AuthenticatedReportsGrnRegisterRoute: AuthenticatedReportsGrnRegisterRoute,
  AuthenticatedReportsInsuranceClaimsRoute:
    AuthenticatedReportsInsuranceClaimsRoute,
  AuthenticatedReportsInsuranceRegisterRoute:
    AuthenticatedReportsInsuranceRegisterRoute,
  AuthenticatedReportsLicenceComplianceRoute:
    AuthenticatedReportsLicenceComplianceRoute,
  AuthenticatedReportsLowStockSparesRoute:
    AuthenticatedReportsLowStockSparesRoute,
  AuthenticatedReportsNabhEvidenceRoute: AuthenticatedReportsNabhEvidenceRoute,
  AuthenticatedReportsOpenTicketsRoute: AuthenticatedReportsOpenTicketsRoute,
  AuthenticatedReportsPmComplianceRoute: AuthenticatedReportsPmComplianceRoute,
  AuthenticatedReportsPoRegisterRoute: AuthenticatedReportsPoRegisterRoute,
  AuthenticatedReportsProcurementCycleRoute:
    AuthenticatedReportsProcurementCycleRoute,
  AuthenticatedReportsRepeatedBreakdownAssetsRoute:
    AuthenticatedReportsRepeatedBreakdownAssetsRoute,
  AuthenticatedReportsSpareConsumptionRoute:
    AuthenticatedReportsSpareConsumptionRoute,
  AuthenticatedReportsSpareCostRoute: AuthenticatedReportsSpareCostRoute,
  AuthenticatedReportsSpareMovementRegisterRoute:
    AuthenticatedReportsSpareMovementRegisterRoute,
  AuthenticatedReportsSpareStockRegisterRoute:
    AuthenticatedReportsSpareStockRegisterRoute,
  AuthenticatedReportsSpareStockReorderRoute:
    AuthenticatedReportsSpareStockReorderRoute,
  AuthenticatedReportsSpareTransferRegisterRoute:
    AuthenticatedReportsSpareTransferRegisterRoute,
  AuthenticatedReportsTicketDepartmentBreakdownRoute:
    AuthenticatedReportsTicketDepartmentBreakdownRoute,
  AuthenticatedReportsTicketRegisterRoute:
    AuthenticatedReportsTicketRegisterRoute,
  AuthenticatedReportsTicketSlaBreachRoute:
    AuthenticatedReportsTicketSlaBreachRoute,
  AuthenticatedReportsTicketSpareUsageRoute:
    AuthenticatedReportsTicketSpareUsageRoute,
  AuthenticatedReportsUserAuditLogRoute: AuthenticatedReportsUserAuditLogRoute,
  AuthenticatedReportsVendorTicketsRoute:
    AuthenticatedReportsVendorTicketsRoute,
  AuthenticatedReportsWarrantyExpiryRoute:
    AuthenticatedReportsWarrantyExpiryRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedRfqsRfqIdRouteChildren {
  AuthenticatedRfqsRfqIdPrintRoute: typeof AuthenticatedRfqsRfqIdPrintRoute
  AuthenticatedRfqsRfqIdIndexRoute: typeof AuthenticatedRfqsRfqIdIndexRoute
}

const AuthenticatedRfqsRfqIdRouteChildren: AuthenticatedRfqsRfqIdRouteChildren =
  {
    AuthenticatedRfqsRfqIdPrintRoute: AuthenticatedRfqsRfqIdPrintRoute,
    AuthenticatedRfqsRfqIdIndexRoute: AuthenticatedRfqsRfqIdIndexRoute,
  }

const AuthenticatedRfqsRfqIdRouteWithChildren =
  AuthenticatedRfqsRfqIdRoute._addFileChildren(
    AuthenticatedRfqsRfqIdRouteChildren,
  )

interface AuthenticatedRfqsRouteChildren {
  AuthenticatedRfqsRfqIdRoute: typeof AuthenticatedRfqsRfqIdRouteWithChildren
  AuthenticatedRfqsNewRoute: typeof AuthenticatedRfqsNewRoute
  AuthenticatedRfqsIndexRoute: typeof AuthenticatedRfqsIndexRoute
}

const AuthenticatedRfqsRouteChildren: AuthenticatedRfqsRouteChildren = {
  AuthenticatedRfqsRfqIdRoute: AuthenticatedRfqsRfqIdRouteWithChildren,
  AuthenticatedRfqsNewRoute: AuthenticatedRfqsNewRoute,
  AuthenticatedRfqsIndexRoute: AuthenticatedRfqsIndexRoute,
}

const AuthenticatedRfqsRouteWithChildren =
  AuthenticatedRfqsRoute._addFileChildren(AuthenticatedRfqsRouteChildren)

interface AuthenticatedSparesRouteChildren {
  AuthenticatedSparesSpareIdRoute: typeof AuthenticatedSparesSpareIdRoute
  AuthenticatedSparesNewRoute: typeof AuthenticatedSparesNewRoute
  AuthenticatedSparesTransfersRoute: typeof AuthenticatedSparesTransfersRoute
  AuthenticatedSparesIndexRoute: typeof AuthenticatedSparesIndexRoute
}

const AuthenticatedSparesRouteChildren: AuthenticatedSparesRouteChildren = {
  AuthenticatedSparesSpareIdRoute: AuthenticatedSparesSpareIdRoute,
  AuthenticatedSparesNewRoute: AuthenticatedSparesNewRoute,
  AuthenticatedSparesTransfersRoute: AuthenticatedSparesTransfersRoute,
  AuthenticatedSparesIndexRoute: AuthenticatedSparesIndexRoute,
}

const AuthenticatedSparesRouteWithChildren =
  AuthenticatedSparesRoute._addFileChildren(AuthenticatedSparesRouteChildren)

interface AuthenticatedStoreIndentsIdRouteChildren {
  AuthenticatedStoreIndentsIdAllocateItemIdRoute: typeof AuthenticatedStoreIndentsIdAllocateItemIdRoute
}

const AuthenticatedStoreIndentsIdRouteChildren: AuthenticatedStoreIndentsIdRouteChildren =
  {
    AuthenticatedStoreIndentsIdAllocateItemIdRoute:
      AuthenticatedStoreIndentsIdAllocateItemIdRoute,
  }

const AuthenticatedStoreIndentsIdRouteWithChildren =
  AuthenticatedStoreIndentsIdRoute._addFileChildren(
    AuthenticatedStoreIndentsIdRouteChildren,
  )

interface AuthenticatedStoreIndentsRouteChildren {
  AuthenticatedStoreIndentsIdRoute: typeof AuthenticatedStoreIndentsIdRouteWithChildren
  AuthenticatedStoreIndentsNewRoute: typeof AuthenticatedStoreIndentsNewRoute
  AuthenticatedStoreIndentsIndexRoute: typeof AuthenticatedStoreIndentsIndexRoute
}

const AuthenticatedStoreIndentsRouteChildren: AuthenticatedStoreIndentsRouteChildren =
  {
    AuthenticatedStoreIndentsIdRoute:
      AuthenticatedStoreIndentsIdRouteWithChildren,
    AuthenticatedStoreIndentsNewRoute: AuthenticatedStoreIndentsNewRoute,
    AuthenticatedStoreIndentsIndexRoute: AuthenticatedStoreIndentsIndexRoute,
  }

const AuthenticatedStoreIndentsRouteWithChildren =
  AuthenticatedStoreIndentsRoute._addFileChildren(
    AuthenticatedStoreIndentsRouteChildren,
  )

interface AuthenticatedTicketsRouteChildren {
  AuthenticatedTicketsTicketIdRoute: typeof AuthenticatedTicketsTicketIdRoute
  AuthenticatedTicketsNewRoute: typeof AuthenticatedTicketsNewRoute
  AuthenticatedTicketsIndexRoute: typeof AuthenticatedTicketsIndexRoute
}

const AuthenticatedTicketsRouteChildren: AuthenticatedTicketsRouteChildren = {
  AuthenticatedTicketsTicketIdRoute: AuthenticatedTicketsTicketIdRoute,
  AuthenticatedTicketsNewRoute: AuthenticatedTicketsNewRoute,
  AuthenticatedTicketsIndexRoute: AuthenticatedTicketsIndexRoute,
}

const AuthenticatedTicketsRouteWithChildren =
  AuthenticatedTicketsRoute._addFileChildren(AuthenticatedTicketsRouteChildren)

interface AuthenticatedTransfersRouteChildren {
  AuthenticatedTransfersTransferIdRoute: typeof AuthenticatedTransfersTransferIdRoute
  AuthenticatedTransfersNewRoute: typeof AuthenticatedTransfersNewRoute
  AuthenticatedTransfersIndexRoute: typeof AuthenticatedTransfersIndexRoute
}

const AuthenticatedTransfersRouteChildren: AuthenticatedTransfersRouteChildren =
  {
    AuthenticatedTransfersTransferIdRoute:
      AuthenticatedTransfersTransferIdRoute,
    AuthenticatedTransfersNewRoute: AuthenticatedTransfersNewRoute,
    AuthenticatedTransfersIndexRoute: AuthenticatedTransfersIndexRoute,
  }

const AuthenticatedTransfersRouteWithChildren =
  AuthenticatedTransfersRoute._addFileChildren(
    AuthenticatedTransfersRouteChildren,
  )

interface AuthenticatedWorkOrdersWoIdRouteChildren {
  AuthenticatedWorkOrdersWoIdPmExecutionRoute: typeof AuthenticatedWorkOrdersWoIdPmExecutionRoute
  AuthenticatedWorkOrdersWoIdIndexRoute: typeof AuthenticatedWorkOrdersWoIdIndexRoute
}

const AuthenticatedWorkOrdersWoIdRouteChildren: AuthenticatedWorkOrdersWoIdRouteChildren =
  {
    AuthenticatedWorkOrdersWoIdPmExecutionRoute:
      AuthenticatedWorkOrdersWoIdPmExecutionRoute,
    AuthenticatedWorkOrdersWoIdIndexRoute:
      AuthenticatedWorkOrdersWoIdIndexRoute,
  }

const AuthenticatedWorkOrdersWoIdRouteWithChildren =
  AuthenticatedWorkOrdersWoIdRoute._addFileChildren(
    AuthenticatedWorkOrdersWoIdRouteChildren,
  )

interface AuthenticatedWorkOrdersRouteChildren {
  AuthenticatedWorkOrdersWoIdRoute: typeof AuthenticatedWorkOrdersWoIdRouteWithChildren
  AuthenticatedWorkOrdersNewRoute: typeof AuthenticatedWorkOrdersNewRoute
  AuthenticatedWorkOrdersIndexRoute: typeof AuthenticatedWorkOrdersIndexRoute
}

const AuthenticatedWorkOrdersRouteChildren: AuthenticatedWorkOrdersRouteChildren =
  {
    AuthenticatedWorkOrdersWoIdRoute:
      AuthenticatedWorkOrdersWoIdRouteWithChildren,
    AuthenticatedWorkOrdersNewRoute: AuthenticatedWorkOrdersNewRoute,
    AuthenticatedWorkOrdersIndexRoute: AuthenticatedWorkOrdersIndexRoute,
  }

const AuthenticatedWorkOrdersRouteWithChildren =
  AuthenticatedWorkOrdersRoute._addFileChildren(
    AuthenticatedWorkOrdersRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedAssetsRoute: typeof AuthenticatedAssetsRouteWithChildren
  AuthenticatedAuditLogsRoute: typeof AuthenticatedAuditLogsRoute
  AuthenticatedAuditsRoute: typeof AuthenticatedAuditsRouteWithChildren
  AuthenticatedCalibrationRoute: typeof AuthenticatedCalibrationRoute
  AuthenticatedComplianceRoute: typeof AuthenticatedComplianceRouteWithChildren
  AuthenticatedCondemnationRoute: typeof AuthenticatedCondemnationRouteWithChildren
  AuthenticatedConfigurationRoute: typeof AuthenticatedConfigurationRoute
  AuthenticatedContractsRoute: typeof AuthenticatedContractsRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDisposalsRoute: typeof AuthenticatedDisposalsRouteWithChildren
  AuthenticatedFinanceRoute: typeof AuthenticatedFinanceRouteWithChildren
  AuthenticatedGrnsRoute: typeof AuthenticatedGrnsRouteWithChildren
  AuthenticatedIndentsRoute: typeof AuthenticatedIndentsRouteWithChildren
  AuthenticatedInsuranceRoute: typeof AuthenticatedInsuranceRouteWithChildren
  AuthenticatedIntegratedAssetsRoute: typeof AuthenticatedIntegratedAssetsRoute
  AuthenticatedInventoryRoute: typeof AuthenticatedInventoryRoute
  AuthenticatedMyAllocationsRoute: typeof AuthenticatedMyAllocationsRoute
  AuthenticatedPreventiveMaintenanceRoute: typeof AuthenticatedPreventiveMaintenanceRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedPurchaseOrdersRoute: typeof AuthenticatedPurchaseOrdersRouteWithChildren
  AuthenticatedPurchaseRequestsRoute: typeof AuthenticatedPurchaseRequestsRoute
  AuthenticatedQuotationComparisonTemplatesRoute: typeof AuthenticatedQuotationComparisonTemplatesRouteWithChildren
  AuthenticatedQuotationTemplatesRoute: typeof AuthenticatedQuotationTemplatesRouteWithChildren
  AuthenticatedReportBreakdownRoute: typeof AuthenticatedReportBreakdownRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedRfqsRoute: typeof AuthenticatedRfqsRouteWithChildren
  AuthenticatedSparesRoute: typeof AuthenticatedSparesRouteWithChildren
  AuthenticatedStoreIndentsRoute: typeof AuthenticatedStoreIndentsRouteWithChildren
  AuthenticatedTicketsRoute: typeof AuthenticatedTicketsRouteWithChildren
  AuthenticatedTransfersRoute: typeof AuthenticatedTransfersRouteWithChildren
  AuthenticatedWorkOrdersRoute: typeof AuthenticatedWorkOrdersRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedAssetsRoute: AuthenticatedAssetsRouteWithChildren,
  AuthenticatedAuditLogsRoute: AuthenticatedAuditLogsRoute,
  AuthenticatedAuditsRoute: AuthenticatedAuditsRouteWithChildren,
  AuthenticatedCalibrationRoute: AuthenticatedCalibrationRoute,
  AuthenticatedComplianceRoute: AuthenticatedComplianceRouteWithChildren,
  AuthenticatedCondemnationRoute: AuthenticatedCondemnationRouteWithChildren,
  AuthenticatedConfigurationRoute: AuthenticatedConfigurationRoute,
  AuthenticatedContractsRoute: AuthenticatedContractsRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDisposalsRoute: AuthenticatedDisposalsRouteWithChildren,
  AuthenticatedFinanceRoute: AuthenticatedFinanceRouteWithChildren,
  AuthenticatedGrnsRoute: AuthenticatedGrnsRouteWithChildren,
  AuthenticatedIndentsRoute: AuthenticatedIndentsRouteWithChildren,
  AuthenticatedInsuranceRoute: AuthenticatedInsuranceRouteWithChildren,
  AuthenticatedIntegratedAssetsRoute: AuthenticatedIntegratedAssetsRoute,
  AuthenticatedInventoryRoute: AuthenticatedInventoryRoute,
  AuthenticatedMyAllocationsRoute: AuthenticatedMyAllocationsRoute,
  AuthenticatedPreventiveMaintenanceRoute:
    AuthenticatedPreventiveMaintenanceRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedPurchaseOrdersRoute:
    AuthenticatedPurchaseOrdersRouteWithChildren,
  AuthenticatedPurchaseRequestsRoute: AuthenticatedPurchaseRequestsRoute,
  AuthenticatedQuotationComparisonTemplatesRoute:
    AuthenticatedQuotationComparisonTemplatesRouteWithChildren,
  AuthenticatedQuotationTemplatesRoute:
    AuthenticatedQuotationTemplatesRouteWithChildren,
  AuthenticatedReportBreakdownRoute: AuthenticatedReportBreakdownRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedRfqsRoute: AuthenticatedRfqsRouteWithChildren,
  AuthenticatedSparesRoute: AuthenticatedSparesRouteWithChildren,
  AuthenticatedStoreIndentsRoute: AuthenticatedStoreIndentsRouteWithChildren,
  AuthenticatedTicketsRoute: AuthenticatedTicketsRouteWithChildren,
  AuthenticatedTransfersRoute: AuthenticatedTransfersRouteWithChildren,
  AuthenticatedWorkOrdersRoute: AuthenticatedWorkOrdersRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface VendorRouteRouteChildren {
  VendorProfileRoute: typeof VendorProfileRoute
  VendorIndexRoute: typeof VendorIndexRoute
  VendorPurchaseOrdersPoIdRoute: typeof VendorPurchaseOrdersPoIdRoute
  VendorRfqsRfqIdRoute: typeof VendorRfqsRfqIdRoute
  VendorGrnsIndexRoute: typeof VendorGrnsIndexRoute
  VendorPurchaseOrdersIndexRoute: typeof VendorPurchaseOrdersIndexRoute
  VendorRfqsIndexRoute: typeof VendorRfqsIndexRoute
}

const VendorRouteRouteChildren: VendorRouteRouteChildren = {
  VendorProfileRoute: VendorProfileRoute,
  VendorIndexRoute: VendorIndexRoute,
  VendorPurchaseOrdersPoIdRoute: VendorPurchaseOrdersPoIdRoute,
  VendorRfqsRfqIdRoute: VendorRfqsRfqIdRoute,
  VendorGrnsIndexRoute: VendorGrnsIndexRoute,
  VendorPurchaseOrdersIndexRoute: VendorPurchaseOrdersIndexRoute,
  VendorRfqsIndexRoute: VendorRfqsIndexRoute,
}

const VendorRouteRouteWithChildren = VendorRouteRoute._addFileChildren(
  VendorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  VendorRouteRoute: VendorRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VendorLoginRoute: VendorLoginRoute,
  AssetSplatRoute: AssetSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
